import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import docTranslations from './i18n-docs';

const storedLang =
  typeof window !== 'undefined' ? localStorage.getItem('i18nextLng') : null;


i18n.use(initReactI18next).init({
  debug: true,
  lng: storedLang || 'en',
  fallbackLng: "en",
  //supportedLngs: ["en", "pt"],
  interpolation: {
    escapeValue: false,
  },

  resources: {
    en: {
      translation: {
        dashboard: {
          title: "Dashboard",
        },
        survey: {
          title: "Survey",
          heading1: "Survey list",
          heading: "Surveys",
          status: "Status",
          published: "Published",
          draft: "Draft",
          search: "Search your survey",
          all: "All",
          duplicate: "Duplicate survey",
          createSurvey: "Create survey",
          surveyName: "Survey name",
          completionResponses: "Completion / responses",
          status: "Status",
          addedOnAddedBy: "Added on / added by",
          lastModified: "Last modified",
          publishedOn: "Published on",
          allL: "All survey",
          export: "Export to excel",
          create1: "Are you ready to create your survey?",
          create2: "Okay, I am ready",
          create3: "Takes just 2 minutes",
          ques2: "What’s your survey name?",
          next: "Next",
          enter: "Enter survey name",
          del1: "Are you sure you want to leave this survey?",
          del2: "Leave survey?",
          logout: "Logout",
          editP: "Edit profile",
          language: "Language",
          assignTO: "Assign to",
          select: "Select",
          ques3: "Provide a short description for the survey",
          ques4: "How many sections you do have in your survey?",
          ques5: "Provide your section names & description",
          ques6: "Section names",
          ques7: "Please select the languages which you want in your survey",
          questions: "Questions",
          sections: "Sections ",
          shareLink: "Share link",
          SectionRequired: "Section name required",
          surveyRequire: "Survey description require",
          numberRequire: "Number of sections require",
          numberGreaterThanZero: "Number must be greater than 0",
          PleaseSelected: "Please select a language",
          enterNumber: "Enter number",

          sectionTitle: "Section title",
          survey_description: "survey_description",
          addDescription: "Add section description here",
          survey_description: "survey_description",
          answerBe: "Answer should be",
          change_type: "Change type",
          change_question_warning:
            "Are you sure, you want to change question type? Changing question type will result in deletion of all data related to this question.",
          change_question_heading: "Change question type?",
          headingR: "Reorder sections",
          text: "Text",
          slider: "Slider",
          multiple_choice: "Multiple choice",
          opinion_scale: "Opinion scale",
          ranking: "Ranking",
          yes_or_no: "Yes or no",
          custom_variables: "Custom variables",
          error_info: "Please enter your question details",
          required: "Required",
          SurveyTitle: "Survey title",
          lRequired: "Label required",
          PRequired: "Placeholder required",
          NRequired: "Name required",
          youCanNot: "You can not delete section",

          actions: {
            editSurvey: "Edit survey",
            shareSurvey: "Share survey",
            moveToDraft: "Move to draft",
            moveToPublish: "Move to publish",
            viewLeads: "View leads",
            duplicate: "Duplicate",
            delete: "Delete",
          },
          variable: {
            heading: "Variables",
            heading1: "Lead-gen variables",
            text1:
              "Lead Gen Variables provide a way to capture and utilize data from a Lead Generation form. Each field in the form is assigned a unique name, which can be used to reference and display the corresponding field value in reports or custom formulas. The syntax to access the value of a lead gen variable is #[leadForm:fieldName]#.",
            nodata: "No data found",
          },

          customVariable: {
            customVariables: "Custom variables",
            text1:
              "Custom Variables provide a way to assign dynamic values based on conditions defined in the Stage module. These variables are standalone and have unique names that can be used to reference and utilize their values throughout the system. The syntax to access the value of a custom variable is #[fieldName]#.",
            label: "Label",
            add_New_Variable: "Add new variable",
            type: "Type",
            varName: "Variable name",
            action: "Action",
            multi: "Multi line text",
            single: "Single line text",
            number: "Number",
            name: "Name",
            description: "Description",
            cancel: "Cancel",
            del1: "Are you sure you want to",
            del2: "Delete custom variable",
            permanently: "permanently?",
            confirm_delete: "Confirm delete",
            max_charaters: "Max. 250 charaters",
            no_spaces: "no spaces",
            edit_Variable: "Edit variable",
            add: "Add variable",
            update: "Update variable",
          },

          customFormula: {
            custom_formula: "Custom formula",
            text1:
              "Custom Formula provide a way to assign dynamic values based on conditions defined in the Stage module. These variables are standalone and have unique names that can be used to reference and utilize their values throughout the system. The syntax to access the value of a custom formula is #[fieldName]#.",
            add_New_formula: "Add custom formula",
            type: "Type",
            forName: "Formula",
            name: "Name",
            description: "Description",
            cancel: "Cancel",
            del1: "Are you sure you want to",
            del2: "Delete custom formula",
            permanently: "permanently?",
            confirm_delete: "Confirm delete",
            max_charaters: "Max. 250 charaters",
            no_spaces: "no spaces",
            edit_formula: "Edit formula",
            type_symbols: "Type your formula using symbols -",
            with_variables: " with variables.",
            delete: "Delete link",
            edit: "Edit formula",
            add: "Add formula",
            update: "Update formula",
            enterFormula: "Enter formula",
          },
          stages: {
            title: "Stages",
            text: "The stage represents a different level of maturity and progress, based on factors such as knowledge and experience of cloud technology, level of planning and preparation, and the extent to which they have begun the process of migrating to the cloud.",
            stagesName: "Stages name",
            add_Date: "Added date",
            add: "Add stage",
            edit: "Edit stage",
            if: "If",
            ranges: "ranges",
            and: "and",
            enter1: "Enter range 1",
            enter2: "Enter range 2",
            del: "Delete stage",
            then: "Then",
            update: "Update",
            add: "Add",
          },
          utm: {
            title: "UTM campaign variables",
            text: "Track the source and medium of your survey campaigns for better insights and data analysis.",
            campaign: "Campaign",
            medium: "Medium",
            source: "Source",
            text1: "Are you sure you want to delete permanently UTM variable?",
            add: "+ Add",
          },
          builder: {
            title: "Form builder",
            edit: "Edit",
            preview: "Preview",
            add: "Add field",
            required: "Required",
            delete: "Delete field",
            edit1: "Edit field",
            save: "Save",
            hidden: "Hidden input",
            textfield: "Text field",
            area: "Text area",
            email: "Email",
            drop: "Drop down",
            num: "Phone number",
            check: "Checkboxes",
            radio: "Radio buttons",
            hidden1: "Hidden",
            labelField: "Label",
            name: "Name",
            label: "Label",
            value: "Default value",
            place: "Placeholder",
            option: "Options",
            addOptions: "Add option",
            optionMinRequired: "At least one option is required and cannot be deleted",
            editLabel: "Edit label",
            labelContent: "Content",
            labelContentPlaceholder: "Enter label HTML content, e.g. <a href=\"https://example.com\">Link text</a>",
            editButton: "Edit button",
            goAhead: "Go ahead",
            alignment: "Alignment",
            text12:
              "Yes, I wish to receive marketing from Vodafone Limited relating to our products and latest offers",
            btnText: "Button text",
            center: "Center",
            left: "Left",
            right: "Right",
            "edit_t&c": "Edit T&C",
            add_heading: "Add heading",
            add_description: "Add description",
            submit: "Submit",
            maxLength: "Max length",
            enter_max_length: "Enter maximum length",
            only_numbers: "Only numbers",
            bannerImage: "Banner image",
            bannerImageHelp: "Please upload an image up to 5 MB in size, with dimensions of 951 × 875 pixels.",
            bannerUploadSuccess: "Banner image uploaded successfully",
            bannerUploadFailed: "Failed to upload banner image",
            bannerSizeError: "Please upload an image up to 5MB",

            privacyHeading: "Privacy heading",
            option1: "Option 1",
            option2: "Option 2",
            option: "Option",
            businessValidation: "Business email validation",
          },
          report: {
            title: "Report",
            title1: "Report builder",
            create: "Create report",
            new: "Create new",
            scratch: "Create new report from scratch",
            template1: "Report template 1",
            text1: "It will be downloaded after completion of survey",
            recently: "Recently edited",
            no: " No recently edited reports found.",
            temp_name: "Template name",
            duplicate: "Duplicate",
            delete: "Delete",
            make: "Make it default",
            del1: "Are you sure you want to delete page?",
            del2: "Delete page",
            saver: "Save report",
            showPage6: "Show assessment page",
          },

          leadErasure: {
            title: "Lead erasure rules",
            add_rule: "Add rule",
            edit_rule: "Edit rule",
            col_type: "Type",
            col_description: "Description",
            col_status: "Status",
            col_actions: "Actions",
            no_rules: "No lead erasure rules configured.",
            rule_type: "Rule type",
            field: "Field",
            utm_field: "UTM field",
            operator: "Operator",
            value: "Value",
            keep_strategy: "Keep strategy",
            active: "Active",
            select_field: "Select a field...",
            enter_value: "Enter value...",
            enter_days: "Enter number of days...",
            starts_with_hint: "Comma-separate multiple prefixes, e.g. 4,7,8",
            regex_hint: "Enter a valid JavaScript-style regular expression (advanced).",
            regex_pattern_label: "Pattern",
            regex_custom_pattern: "Custom pattern",
            enter_regex_placeholder: "e.g. ^[A-Z]{2}\\d+$",
            regex_preset: {
              custom: "Custom (advanced)",
              letters_only: "Only letters (A–Z, a–z)",
              digits_only: "Only digits (0–9)",
              exactly_9_chars: "Exactly 9 characters",
              nine_same_character: "All 9 characters identical (e.g. 111111111)",
              eight_plus_same_digits: "8+ identical digits in a row",
            },
            edit: "Edit",
            delete: "Delete",
            created: "Rule created successfully.",
            updated: "Rule updated successfully.",
            deleted: "Rule deleted successfully.",
            errors: {
              field_required: "Please select a field.",
              operator_required: "Please select an operator.",
              value_required: "Please enter a value.",
              days_invalid: "Please enter a valid number of days (greater than 0).",
              regex_invalid: "Invalid regular expression. Check your pattern and try again.",
            },
          },

          share: {
            tittle: "Publish & share",
            text1: "How would you like to share survey to people?",
            copy: "Copy link",
            campaign: "Campaign URLs",
            create: "Create new URL",
            name: "Name",
            res: "Responses",
            createdDate: "Created date",
            status: "Status",
            action: "Action",
            name: "Name",
            source: "Source",
            medium: "Medium",
            content: "Content",
            campaign: "Campaign",
            Parameters: "Add parameters",
            add: "Add",
            cancle: "Cancel",
            update: "Update",
            url: "Generated UTM URL",
            text2:
              "Fill out the fields in the form below to add parameters to your survey URL. To automatically get information from your shared link click on each field and select dynamic parameter such as placement = `` .",
            edit1: "Edit campaign URL",
            text2:
              "This is the name of your marketing effort. In short, the name of your campaign, e.g. promo, sale, etc.",
            del1: "Are you sure you want to delete",
            validation: "Please complete all required fields",
            linkCopied: "Link copied",
          },
          groups: {
            menu: "Survey group",
            title: "Survey groups",
            heading: "One link. Every language.",
            share: "Share survey group",
            group: "Groups",
            removeGroup: "Remove from the group",
            makePrimary: "Make it primary",
            addTOGroup: "Add to group",
            caption: "Bundle localized surveys, set a primary experience, and share a single URL with automatic language switching.",
            createBtn: "Create group",
            createTitle: "Create survey group",
            manageTitle: "Manage survey group",
            groupName: "Group name",
            selectSurvey: "Add survey",
            selectPlaceholder: "Select survey to include",
            addToGroup: "Add to group",
            noSurveysSelected: "No surveys selected yet.",
            primary: "Primary",
            untitledSurvey: "Untitled survey",
            untitledGroup: "Untitled group",
            loading: "Loading group details...",
            delete: "Delete group",
            saveDetails: "Save details",
            saveOrdering: "Save ordering",
            langConflict: "A survey with this language already exists in the group.",
            selectAll: "Select all",
            languageRestriction: "You can select only one survey for each language",
            languageAlreadySelected: "Language already selected",
            totalSurveys: "Total surveys",
            addedOnAddedBy: "Added on / added by",
            rename: "Rename",
            deleteGroup: "Delete survey group",
            deleteWarning: "Warning!",
            deleteMessage: "Deleting",
            deleteConfirmation: "will remove it permanently. This action cannot be undone.",
            areYouSure: "Are you sure you want to delete this survey group?",
            renameGroup: "Rename group",
            enterGroupName: "Enter group name",
            groupNamePlaceholder: "Enter new group name",
            surveyGroup: "Survey group",
            individualSurvey: "Individual survey",
            home: "Home",
            responses: "Responses",
            sections: "Sections",
            questions: "Questions",
            unknownSurvey: "Unknown survey",
            noLanguageCode: "No language code",
            removeSurvey: "Delete survey",
            removeSurveyConfirm: "Are you sure you want to delete this survey from group?",
            removeSurveyWarning: "from this group will unlink it. The survey itself will remain in your survey list.",
            noSurveysInGroup: "No surveys in this group yet",
            surveyOrderUpdated: "Survey order updated successfully",
            primarySurveyUpdated: "Primary survey updated successfully",
            surveysAddedSuccess: "survey(s) added to group successfully",
            surveyRemovedSuccess: "Survey removed from group successfully",
            cannotAddDuplicateLanguages: "Cannot add surveys with duplicate languages",
            failedToAddSurveys: "Failed to add some surveys",
            pleaseSelectSurvey: "Please select at least one survey to add",
            errors: {
              nameRequired: "Group name is required",
              surveyRequired: "Please add at least one survey",
              slugRequired: "Slug is required for group links",
              languageConflict: "A survey with this language is already selected"
            },
            toast: {
              created: "Survey group created successfully",
              createError: "Failed to create survey group",
              memberAdded: "Survey added to group",
              memberRemoved: "Survey removed from group",
              orderSaved: "Ordering updated",
              detailsSaved: "Group details saved",
              deleted: "Survey group deleted successfully",
              linkCreated: "Group link created",
              linkError: "Unable to create link",
              linkUpdated: "Group link updated",
              renamed: "Group renamed successfully",
              renameError: "Failed to rename group",
              deleteError: "Failed to delete group",
              selectAtLeastOne: "Select at least one survey to create a group",
              languageDuplicateSkipped: "Some surveys were skipped due to duplicate languages"
            },
            steps: {
              createTitle: "Create logical groups",
              createDesc: "Select the localized surveys that belong together.",
              orderTitle: "Control order & primary",
              orderDesc: "Drag to reorder and set the default survey experience.",
              publishTitle: "Publish multi-language links",
              publishDesc: "Share one URL and let respondents switch languages."
            },
            table: {
              name: "Group name",
              languages: "{{count}} languages",
              primary: "Primary survey",
              updated: "Created",
              actions: "Actions"
            },
            actions: {
              manage: "Edit",
              edit: "Edit",
              linkWorkspace: "Link workspace"
            },
            emptyState: "No survey groups yet. Create your first group to get started.",
            links: {
              heading: "Group URLs",
              subheading: "Manage links for {{name}}",
              closeWorkspace: "Close workspace",
              previewLabel: "Base link",
              previewPlaceholder: "Group URL preview will appear here",
              empty: "No links created for this group yet."
            },
            slugLabel: "Group slug",
            previewLabel: "Base link",
            previewPlaceholder: "Group URL preview",
            addToGroupBtn: "Add selected survey"
          },
          question: {
            title: "Q&A builder",
            multi: "Multiple choice",
            text: "Text",
            scale: "Opinion scale",
            q: "Q",
            del1: "Delete question",
            del2: "Are you sure, you want to delete question? Deleting question type will result in deletion of all data related to this question.",
            enter: "Please enter question",
            editq: "Edit question",
            duplicateq: "Duplicate question",
            recorder: "Reorder question",
            addq: "Add question",
            adds: "Add section",
            questions: "Questions",
            question: "Question",
            sections: "Sections",
            name: "Section name",
            description: "Add your survey description here",
            del_section1: "Delete this section?",
            del_section2: "Please select an option to continue",
            del_section3: " Delete this section and merge questions to",
            del_section4: "Delete this section with all its questions.",
            next: "next",
            previous: "previous",
            texts: "Survey name is required",
            edits: "Edit section",
            duplicates: "Duplicate section",
            recorders: "Reorder section",
            deletes: "Delete section",
          },
          sidebar: {
            email_templates: "Email templates",
            webhooks: "Webhooks",
            cookie_policy: "Cookie policy",
          },
          email_template: {
            breadcrumb: "Email template",
            page_title: "Email template editor",
            email_subject: "Email subject",
            subject_placeholder: "Your Report is Ready",
            email_enabled: "Email enabled",
            email_disabled: "Email disabled",
            reset_to_default: "Reset to default",
            saving: "Saving...",
            save_template: "Save template",
            toast_enabled: "Report email enabled",
            toast_disabled: "Report email disabled",
            toast_saved: "Email template saved",
            toast_reverted: "Reverted to default email template",
            toast_copied: "Copied {{text}} — paste it into any text field",
            toast_copy_fallback: "Copy this: {{text}}",
            click_to_copy: "Click to copy",
            section_general: "General",
            section_heading: "Heading",
            section_description: "Description",
            section_button: "Button",
            section_notes: "Notes & assistance",
            section_signoff: "Sign-off",
            section_footer: "Footer",
            section_placeholders: "Placeholders",
            label_email_bg: "Email BG",
            label_card_bg: "Card BG",
            label_font: "Font",
            label_padding: "Padding",
            label_color: "Color",
            label_font_size: "Font size",
            label_bg_color: "BG color",
            label_text_color: "Text color",
            label_section_bg: "Section BG",
            label_radius: "Radius",
            label_height: "Height",
            label_width: "Width",
            label_border: "Border",
            label_security_note: "Security note",
            label_assistance_note: "Assistance note",
            placeholder_desc: "Click a placeholder to copy it, then paste into any text field in the preview. These are <strong>optional</strong> &mdash; if you remove one, that value simply won't appear in the sent email.",
            placeholder_org_name: "Your organization display name (e.g. \"Vodafone Support\")",
            placeholder_support_email: "Support email address (e.g. \"support@vodafone.com\")",
            placeholder_report_url: "Link to the generated report (auto-inserted in button)",
            reset_title: "Reset to default",
            reset_warning: "This will revert the email template to its default state. All your customizations (text, colors, styles) will be permanently lost.",
            reset_confirm: "Yes, reset",
            reset_cancel: "Cancel",
          },
          cookie_policy_page: {
            breadcrumb: "Cookie policy",
            page_title: "Cookie policy",
            page_description: "Manage the cookie policy content for this survey. Toggle visibility in the survey footer.",
            show_in_footer: "Show cookie policy in survey footer",
            enabled: "Enabled",
            disabled: "Disabled",
            banner_settings: "Cookie banner button settings",
            accept_button: "Accept button",
            reject_button: "Reject button",
            show: "Show",
            hidden: "Hidden",
            button_text_label: "Button text (leave empty for default translation)",
            accept_placeholder: "e.g. Accept All Cookies",
            reject_placeholder: "e.g. Reject All",
            saving: "Saving...",
            save: "Save",
          },
        },
        privacyPolicy: {
          heading: "Privacy policy",
          title: "Configure or attach your survey privacy policy here."
        },
        activityLog: {
          title: "Activity log",
          message: "Message",
          action: "Action",
          added_by: "Added by",
          date_time: "Date & time",
        },
        activityTemplate: {
          title: "Activity logs template",
          add: "Add activity template",
          TemplateAction: "Template action",
          TemplateText: "Template text",
          TemplateCode: "Template code",
          AddedBy: "Added by",
          AddedDate: "Added date",
          addTemplateCodeLabel: "Template code",
          TemplateCodePlaceholder: "Enter template code...",
          TemplateActionLabel: "Template action",
          TemplateActionPlaceholder: "Enter template action...",
          TemplateTextLabel: "Template text",
          TemplateTextPlaceholder: "Enter template text...",
          DependencyArrayLabel: "Dependency array",
          DependencyArrayPlaceholder: "Enter dependency array...",
          desc: "The Activity Log provides a comprehensive record of all actions and events within the system. It allows you to track changes and monitor user activity.",
        },
        activityLogTemplate: {
          templateCodeRequired: "Template code is required",
          templateActionRequired: "Template action is required",
          templateTextRequired: "Template text is required",
          dependencyArrayRequired: "Dependency array is required",
        },

        analytics: {
          title: "Analytics",
          heading: "Analytics",
          select: "Select survey",
          text1: "View all",
          select_survey: "Select survey",
          date: "Date",
          completion_analysis: "Completion analysis",
          maturity_analysis: "Maturity analysis",
          question_wise: "Question wise",
          exits_analysis: "Exits analysis",
          last_month: "Last month",
          last7: "Last 7 days",
          this: "This month",
          last30: "Last 30 days",
          today: "Today",
          yesterday: " Yesterday",
          notAns: "Not answered",
          complete: "Complete",
          question: "Questions",
          respondentCount: "Respondent count",
          surveyCount: "Survey count",
          inComplete: "Incomplete",
          all: "All",
          link: "Link",
          utm_source: "UTM source",
          utm_medium: "UTM medium",
          utm_campaign: "UTM campaign",
          del1: "Deleting this lead will permanently remove it from the system.Are you sure you want to continue?",
          del2: "Delete lead",
          del3: "Delete selected leads",
          del4: "selected leads? This action cannot be undone.",
          TANDC: "Marketing prefs",

          top_10_leads: {
            heading: "Top 10 leads generated",
            description:
              "Displays details of top 10 generated leads. Click on any column to sort the data. Export to Excel for detailed analysis.",
          },
          date_of_survey: "Date of survey",
          report_link: "Report link",
          first_name: "First name",
          last_name: "Last name",
          email_address: "Email address",
          phone_number: "Phone number",
          organization_name: "Organization name",
          industry: "Industry",
          number_of_responses: "No. of responses",
          maturity_level: "Maturity level",
          total_score: "Total score",
          completed: "Completed",
          unique_id: "Unique ID",
          tab_all: "All",
          tab_archived: "Archived",
          archived_by_rule: "Archived by rule",
          delete_permanently: "Delete permanently",
          totals: {
            total_survey_responses: "Total survey responses",
            completed_surveys: "Completed surveys",
            completed_leads: "Completed leads",
          },
        },
        settings: {
          title: "Settings",
          general: "General settings",
          general_breadcrumb: "General settings",
          account_settings: {
            heading: "Profile",
            email: "Email",
            user_name: "User name",
            country: "Country",
            region: "Region",
            timezone: "Timezone",
            save_changes: "Save changes",
            default_language: "Default language",
            assignTeamRole: "Assigned teams and roles",
          },
          security: "Security",
          ticket_notifications: "Notifications",
          organization_details: {
            heading: "Organization details",
            breadcrumb_heading: "Organization details",
            privacy_policy: "Privacy policy",
            terms_of_use: "Terms of use",
            cookie_policy: "Cookie policy",
          },
          users_and_teams: {
            heading: "User management",
            breadcrumb_heading: "User management",
            users: {
              heading: "Users",
              sub_heading:
                "Manage product access for all the users in your organization.",
              search: "Search",
              name: "Name",
              action: "Action",
              edit_action: {
                edit_user: "Edit user",
                full_name: "Full name",
                email_address: "Email address",
                password: "Password",
                cancel: "Cancel",
                save: "Save",
                recently: "Recently added",
                sorta: "Sort A-Z",
                sortb: "Sort Z-A",
              },
              delete_action: {
                heading: "Delete users",

                sub_heading: "Warning",
                cancel: "Cancel",
                confirm_delete: "Confirm delete",
                text1:
                  "Are you sure you want to delete these users permanently?",
                text2:
                  "By deleting the users you will be deleting the users from all the Surveys and their permission to access.",
              },
              create_user: {
                heading: "Create user",
                full_name: "Full name",
                email_address: "Email address",
                password: "Password",
                cancel: "Cancel",
                save: "Save",
                enter: "Enter",
              },
            },
          },
          roles: {
            heading: "Roles",
            description:
              "Roles are predefined sets of permissions and responsibilities that are assigned.",
            common: {
              role_name: "Role name",
              select_parent_role: "Select parent role",
              permissions: {
                heading: "Permissions",
                survey: "Survey",
                analytics: "Analytics",
                users: "Users",
                roles: "Roles",
                teams: "Teams",
                actions: {
                  view: "View",
                  write: "Write",
                  read: "Read",
                  delete: "Delete",
                },
              },
              cancel: "Cancel",
              save: "Save",
            },
            create_role: {
              heading: "Create role",
              add_new: "Add new ",
              role: "Role",
              edit: "Edit",
            },
            role_list: {
              sr_no: "Sr.no",
              name: "Name",
              date_added: "Date added",
              action: "Action",
            },
            edit_action: {
              edit_role: "Edit role",
            },
            delete_action: {
              heading: "Delete users",
              sub: "Delete role",
              sub_heading:
                "By deleting the user role you will be deleting the user role from all the Servers and their permission to access.",
              cancel: "Cancel",
              delete: "Delete",
            },
          },
          team: {
            heading: "Teams",
            description:
              "Teams are groups of users working together on specific projects or tasks.",
            create_team: {
              heading: "Create team",
              team_name: "Team name",
              save: "Save",
              cancel: "Cancel",
              member: "Members",
            },
            action: {
              edit: "Edit",
              edit_team: "Edit team",
              team_name: "Team name",
              save: "Save",
              cancel: "Cancel",
              add_member: "Add member",
              select_role: "Select role",
              added_members: "Added members",
              leave: "Leave",
              owner: "Owner",
              delete: {
                heading: "Delete team",
                warning: "Warning",
                text: "By deleting this team you will be deleting all the team members and related information.",
                cancel: "Cancel",
                confirm_delete: "Confirm",
              },
            },
            sort_by: "Sort by",
          },
          integration: {
            tittle: "Integration",
            text: "You can make a bridge between eloqua form and assessment form.",
            eloqua: "Eloqua",
            save: "Save",
            formURL: "Form URL",
            companyName: "Company name",
            userName: "User name",
            password: "Password",
            settings: "Settings",
          },
          questionnaire: {
            title: "Questionnaire",
            "assessments​": "Assessments​",
            pageHeading: "Page heading",
            buttontext: "Button text",
            buttonNextText: "Button next",
            buttonHeadingText: "Button submit",
            buttonBack: "Button back",
            save: "Save",
            reportPageHeading: "Report page heading",
            reportHeading: "Report heading",
            stage: "Stage",
            stage1: "Stage 1",
            stage2: "Stage 2",
            stage3: "Stage 3",
            stage4: "Stage 4",
            stage5: "Stage 5",
            report: "Report",
            hint: " Please enter hint",
            choice: "Choice",
          },
          thankyouPage: {
            title: "Thank you page",
            pageHeading: "Page heading",
            pageDescription: "Page description",
            buttonText1: "View report button",
            buttonText2: "Download report button",
          },
          CustomVairable: {
            linkCustom: "Link a custom variable",
            variableLabel: "Variable label",
            variableName: "Variable name",
            value: "Value",
            action: "Action",
            noDataFound: "No data found",
            editVariable: "Edit variable",
            addVariable: "Add variable",
            deleteVariable: "Delete variable",
            enterValue: "Enter value",
            cancel: "Cancel",
            save: "Save",
            loading: "Loading...",
            confirmDelete: "Confirm delete",
            areYouSure: "Are you sure you want to delete variable",
            addSection: "Add section",
            editSection: "Edit section",
            duplicateSection: "Duplicate section",
            reorderSection: "Reorder section",
            deleteSection: "Delete section",
            selectVariable: "Select variable",
            newchoices: "Add new choices",
            score: "Score",
            variable: "Variable",
            select: "Select",
          },
          save_changes: "Save changes",
          loading: "Loading...",
          loading_settings: "Loading settings...",
          security_settings: {
            title: "Security settings",
            description: "Configure login security for all users.",
            sso_title: "Microsoft SSO",
            sso_description: "Allow users to sign in using their Microsoft (Azure AD) account. When disabled, the \"Sign in with Microsoft\" button will be hidden from the login page.",
            mfa_title: "Multi-factor authentication (MFA)",
            mfa_description: "When enabled, users must verify their identity with a 6-digit code sent to their email after entering their password. The code expires after 10 minutes.",
            lockout_title: "Account lockout",
            lockout_description: "Automatically lock user accounts after multiple failed login attempts to prevent brute-force attacks.",
            max_attempts: "Max failed attempts",
            lock_duration: "Lock duration",
            minutes: "minutes",
            password_expiry_title: "Password expiry",
            password_expiry_description: "Force users to change their password after a set number of days. Users will be redirected to a password reset page upon login if their password has expired.",
            expire_after: "Expire after",
            disabled: "Disabled",
            days: "days",
            success: "Security settings updated successfully",
            error: "Failed to update settings",
          },
          ticket_notification_settings: {
            title: "Ticket notification settings",
            description: "Select users who should receive email notifications when a new ticket is created or a ticket is assigned.",
            recipients_title: "Email notification recipients",
            recipients_description: "These users will receive an email whenever a ticket is created (by a user or automatically by the system). Additionally, when a ticket is assigned to a user, that user will receive an assignment notification email.",
            add_users: "Add users",
            search_placeholder: "Search users by name or email...",
            no_users: "No users selected. Search and add users above.",
            remove: "Remove",
            success: "Notification recipients updated successfully",
            error: "Failed to update recipients",
          },
          organization_details_page: {
            edit_description: "Edit the {{title}} content displayed on the login page.",
            success: "{{title}} updated successfully",
            error: "Failed to update",
          },
          editor: {
            bold: "Bold",
            italic: "Italic",
            underline: "Underline",
            bulleted_list: "Bulleted list",
            numbered_list: "Numbered list",
            link: "Link",
            table: "Table",
            text_color: "Text color",
            color: "Color",
            no_color: "No color",
            url_prompt: "URL",
          },
        },
        tickets: {
          title: "Tickets",
          create_ticket: "+ Create ticket",
          search_placeholder: "Search tickets...",
          no_tickets: "No tickets found",
          created_success: "Ticket created successfully",
          view: "View",
          view_details: "View ticket details",
          dashboard: {
            open: "Open",
            acknowledged: "Acknowledged",
            in_progress: "In progress",
            resolved: "Resolved",
            total: "Total",
          },
          status: {
            open: "Open",
            acknowledged: "Acknowledged",
            in_progress: "In progress",
            resolved: "Resolved",
            false_positive: "False positive",
          },
          alert_type: {
            brute_force: "Brute force",
            unauthorized_token: "Unauthorized token",
            unknown_user: "Unknown user",
            inactive_user: "Inactive user",
            suspicious_ip: "Suspicious IP",
            after_hours: "After hours",
            manual: "Manual",
          },
          columns: {
            title: "Title",
            type: "Type",
            severity: "Severity",
            status: "Status",
            source: "Source",
            assigned_to: "Assigned to",
            created: "Created",
            action: "Action",
          },
          filters: {
            all_statuses: "All statuses",
            all_severities: "All severities",
            all_sources: "All sources",
            all_assignees: "All assignees",
            unassigned: "Unassigned",
          },
          severity: {
            low: "Low",
            medium: "Medium",
            high: "High",
            critical: "Critical",
          },
          source: {
            system: "System",
            user: "User",
          },
          create: {
            title: "Create ticket",
            title_label: "Title *",
            title_placeholder: "Brief description of the issue",
            title_required: "Title is required",
            title_max: "Title must be 255 characters or fewer",
            severity_label: "Severity *",
            severity_required: "Severity is required",
            severity_placeholder: "Select severity...",
            description_label: "Description",
            description_max: "Description must be 2000 characters or fewer",
            description_placeholder: "Provide additional details...",
            assign_to: "Assign to",
            unassigned: "Unassigned",
            cancel: "Cancel",
            creating: "Creating...",
            submit: "Create ticket",
          },
          detail: {
            back: "Back to Tickets",
            not_found: "Ticket not found.",
            status: "Status",
            severity: "Severity",
            alert_type: "Alert Type",
            source: "Source",
            ip_address: "IP Address",
            raised_by: "Raised By",
            assigned_to: "Assigned To",
            created: "Created",
            resolved: "Resolved",
            resolved_by: "by {{name}}",
            comments: "Comments ({{count}})",
            no_comments: "No comments yet.",
            unknown_user: "Unknown",
            add_comment_placeholder: "Add a comment...",
            posting: "Posting...",
            post_comment: "Post Comment",
            update_status: "Update Status",
            updating: "Updating...",
            assign_to: "Assign To",
            select_user: "Select user...",
            assigning: "Assigning...",
            assign_btn: "Assign",
            status_updated: "Status updated",
            status_update_failed: "Failed to update status",
            assigned: "Ticket assigned",
            assign_failed: "Failed to assign ticket",
            comment_added: "Comment added",
            comment_failed: "Failed to add comment",
          },
        },
        documentation: {
          ...docTranslations.en.documentation,
          title: "Documentation",
        },

        webhook: {
          url: "URL",
          title: "webhooks",
          webhook: "webhook",
          createTitle: "Create new webhook",
          editTitle: "Edit webhook",
          name: "Enter name",
          event: "Events",
          add: "Add webhook",
          desc: "Enter description",
          active: "Active",
          inactive: "Inactive",
          generateURl: "Generated webhook URL",
          delete: "Delete webhook",
          delete1:
            "Deleting this webhook will disable its triggers for all events it's associated with. This action cannot be undone. Are you sure?",
          recently: "Recently added",
          example: "https\\:example4.com",
          remove: "Remove",
          assign: "Assign team",

          method: "Method",
          content_type: "Content-type",
          data_format: "Data format",
          parameters: "Parameters",
          preview: "Preview",

          validation: {
            name_required: "Name is required",
            url_required: "URL is required",
            url_invalid: "Invalid URL",
            event_required: "Event is required",
            http_method_required: "HTTP method is required",
            http_method_oneof: "Invalid HTTP method",
            content_type_required: "Content type is required",
            data_format_required: "Data format is required",
            data_format_invalid: "Invalid data format",
            params_name_required: "Name required",
            params_value_required: "Value required",
            get_no_body:
              "GET requests cannot have request body. Please use Query Parameters for GET requests.",
          },
        },
        sync: {
          syncFromUat: "Sync from UAT",
          versionHistory: "Version history",
          survey: "Survey",
          mode: "Mode",
          fullReplacement: "Full replacement",
          merge: "Merge",
          cancel: "Cancel",
          next: "Next",
          loading: "Loading...",
          sync: "Sync",
          syncing: "Syncing...",
          close: "Close",
          acceptAndSync: "Accept & Sync",
          merging: "Merging...",
          loadingSurveys: "Loading surveys...",
          noSurveysFound: "No surveys found.",
          fullReplacementNote: "A version snapshot will be created before replacement to allow rollback if needed.",
          mergeNote: "Click Next to see new items and conflicts. UAT version will be used for conflicts.",
          noteLabel: "Note:",
          mergeModeLabel: "Merge Mode:",
          showLatestVersions: "Show only latest 5 versions",
          version: "Version",
          type: "Type",
          date: "Date",
          action: "Action",
          loadingVersions: "Loading versions...",
          beforeRestore: "Before restore",
          beforeRestoreToVersion: "Before restore to Version",
          beforeMerge: "Before merge from UAT",
          beforeSync: "Before sync from UAT",
          restoring: "Restoring...",
          restore: "Restore",
          noVersionsFound: "No versions found.",
          mergePreview: "Merge preview",
          conflictsWarning: "Conflicts",
          conflictsDescription: "Same UUID, different content. UAT version will replace Primary.",
          newItems: "New items",
          duplicatesWarning: "Duplicates",
          duplicatesDescription: "Different UUID, same content. Both versions will be kept.",
          noChanges: "No changes to merge. Survey is already in sync.",
          new: "New",
          conflicts: "Conflicts",
          duplicates: "Duplicates",
          questions: "Questions",
          sections: "Sections",
          variables: "Variables",
          leadGenVariables: "Lead gen variables",
          utmVariables: "UTM variables",
          customFormulas: "Custom formulas",
          stages: "Stages",
          reportPages: "Report pages",
          customVariableValues: "Custom variable values",
          reports: "Reports",
          surveyLinks: "Survey links",
          webhooks: "Webhooks",
          privacyPolicy: "Privacy policy",
          questionnaire: "Questionnaire",
          thankYouPage: "Thank you page",
          toast: {
            linkCopied: "Link copied to clipboard",
            invalidVersionSelected: "Invalid version selected",
            restoredSuccess: "Restored to v{{version}}! Backup v{{backup}} created.",
            restoreFailed: "Failed to restore version",
            noSurveySelected: "No survey selected for sync",
            syncCompletedWithBackup: "Sync completed! Version v{{version}} created as backup.",
            surveySyncedSuccess: "Survey synced successfully",
            fullReplacementFailed: "Full replacement sync failed",
            clickPreviewFirst: "Please click Next to see changes before merging",
            previewFailed: "Preview failed",
            mergeCompletedSuccess: "Merge completed successfully",
            mergeFailed: "Merge failed",
            surveyDuplicatedSuccess: "Survey duplicated successfully",
            surveyDuplicateFailed: "Failed to duplicate survey. Please try again.",
            surveyDeletedSuccess: "Survey deleted successfully",
            surveyDeleteFailed: "Failed to delete survey. Please try again.",
            selectSurveyToSync: "Please select a survey to sync.",
            fetchUatSurveysFailed: "Failed to fetch UAT surveys",
            noGroupSelected: "No group selected.",
            noSurveysSelectedToAdd: "No surveys selected to add.",
            surveysAddedToGroup: "{{count}} survey(s) added to {{groupName}} successfully.",
            duplicateLanguagesWarning: "Cannot add surveys with duplicate languages to the same group",
            failedToAddSurveys: "Failed to add some surveys",
          },
        },
      },
    },

    pt: {
      translation: {
        dashboard: {
          title: "Painel",
        },
        survey: {
          title: "Inquérito",
          heading1: "Lista de inquéritos",
          heading: "Inquéritos",
          status: "Estatuto",
          published: "Publicado",
          draft: "Rascunho",
          search: "Pesquise o seu inquérito",
          all: "Todos",
          duplicate: "Duplicar inquérito",
          createSurvey: "Criar inquérito",
          surveyName: "Nome do inquérito",
          completionResponses: "Concluídos / respostas",
          status: "Estatuto",
          addedOnAddedBy: "Adicionado em / Por",
          lastModified: "Última modificação",
          publishedOn: "Publicado em",
          allL: "Todas as pesquisas",
          export: "Exportar para excel",
          create1: "Está pronto para criar a sua pesquisa?",
          create2: "Ok, estou pronto",
          create3: "Demora apenas 2 minutos",
          ques2: "Qual é o nome da sua pesquisa?",
          next: "Seguinte",
          enter: "Introduza o nome da pesquisa",
          del1: "Tem a certeza de que pretende sair desta pesquisa?",
          del2: "Sair da pesquisa?",
          logout: "Sair",
          editP: "Editar perfil",

          language: "Idioma",
          assignTO: "Atribuir PARA",
          select: "Selecione",
          ques3: "Forneça uma breve descrição da pesquisa",
          ques4: "Quantas seções você tem na sua pesquisa?",
          ques5: "Forneça os nomes e as descrições das suas seções",
          ques6: "Nomes das seções",
          ques7:
            "Por favor, selecione os idiomas que você deseja na sua pesquisa",
          questions: "Perguntas",
          sections: "Seções",
          shareLink: "Compartilhar link",
          SectionRequired: "Nome da secção obrigatório",
          surveyRequire: "Descrição do inquérito obrigatória",
          numberRequire: "Número de secções obrigatório",
          numberGreaterThanZero: "O número deve ser maior que 0",
          PleaseSelected: "Por favor, selecione um idioma",
          enterNumber: "Introduza o número",

          sectionTitle: "Título da secção",
          survey_description: "Descrição do inquérito",
          addDescription: "Adicionar descrição da secção",
          answerBe: "A resposta deve ser",
          change_type: "Alterar tipo",
          change_question_warning:
            "Tem a certeza de que deseja alterar o tipo de pergunta? Alterar o tipo de pergunta resultará na eliminação de todos os dados relacionados com esta pergunta.",
          change_question_heading: "Alterar o tipo de pergunta?",
          headingR: "Reordenar secções",
          text: "Texto",
          slider: "Deslizador",
          multiple_choice: "Escolha múltipla",
          opinion_scale: "Escala de opinião",
          ranking: "Classificação",
          yes_or_no: "Sim ou não",
          custom_variables: "Variáveis personalizadas",
          error_info: "Por favor, insira os detalhes da pergunta",
          required: "Obrigatório",
          SurveyTitle: "Título da pesquisa",
          lRequired: "Etiqueta obrigatória",
          PRequired: "Texto de preenchimento obrigatório",
          NRequired: "Nome obrigatório",
          youCanNot: "Você não pode excluir a seção",

          actions: {
            editSurvey: "Editar inquérito",
            shareSurvey: "Partilhar inquérito",
            moveToDraft: "Mover para rascunho",
            moveToPublish: "Mover para publicado",
            viewLeads: "Ver leads",
            duplicate: "Duplicar",
            delete: "Eliminar",
          },
          variable: {
            heading: "Variáveis",
            heading1: "Variáveis Lead-gen",
            text1:
              "As Variáveis Lead-gen fornecem uma forma de capturar e utilizar dados de um formulário de Geração de Leads. Cada campo no formulário tem um nome único, que pode ser usado para referenciar e exibir o valor correspondente nos relatórios ou fórmulas personalizadas. A sintaxe para aceder ao valor de uma variável lead-gen é #[leadForm:fieldName]#.",
            nodata: "Nenhum dado encontrado",
          },
          customVariable: {
            customVariables: "Variáveis personalizadas",
            text1:
              "As Variáveis Personalizadas permitem atribuir valores dinâmicos com base nas condições definidas no módulo de Estágio. Estas variáveis são independentes e têm nomes únicos que podem ser usados para referenciar e utilizar os seus valores em todo o sistema. A sintaxe para aceder ao valor de uma variável personalizada é #[fieldName]#.",
            label: "Rótulo",
            add_New_Variable: "Adicionar nova variável",
            type: "Tipo",
            varName: "Nome da variável",
            action: "Ação",
            multi: "Texto de várias linhas",
            single: "Texto de uma linha",
            number: "Número",
            name: "Nome",
            description: "Descrição",
            cancel: "Cancelar",
            del1: "Tem a certeza que deseja",
            del2: "Eliminar variável personalizada",
            permanently: "permanentemente?",
            confirm_delete: "Confirmar eliminação",
            max_charaters: "Máximo de 250 caracteres",
            no_spaces: "sem espaços",
            edit_Variable: "Editar variável",
            add: "Adicionar variável",
            update: "Atualizar variável",
          },
          customFormula: {
            custom_formula: "Fórmula personalizada",
            text1:
              "As Fórmulas Personalizadas permitem atribuir valores dinâmicos com base nas condições definidas no módulo de Estágio. Estas variáveis são independentes e têm nomes únicos que podem ser usados para referenciar e utilizar os seus valores em todo o sistema. A sintaxe para aceder ao valor de uma fórmula personalizada é #[fieldName]#.",
            add_New_formula: "Adicionar fórmula personalizada",
            type: "Tipo",
            forName: "Fórmula",
            name: "Nome",
            description: "Descrição",
            cancel: "Cancelar",
            del1: "Tem a certeza que deseja",
            del2: "Eliminar fórmula personalizada",
            permanently: "permanentemente?",
            confirm_delete: "Confirmar eliminação",
            max_charaters: "Máximo de 250 caracteres",
            no_spaces: "sem espaços",
            edit_formula: "Editar fórmula",
            type_symbols: "Digite a sua fórmula usando símbolos -",
            with_variables: " com variáveis.",
            delete: "Eliminar ligação",
            edit: "Editar fórmula",
            add: "Adicionar fórmula",
            update: "Atualizar fórmula",
            enterFormula: "Digite a fórmula",
          },
          stages: {
            title: "Estágios",
            text: "O estágio representa um nível diferente de maturidade e progresso, com base em fatores como o conhecimento e experiência em tecnologia de nuvem, o nível de planeamento e preparação, e a extensão em que já iniciaram o processo de migração para a nuvem.",
            stagesName: "Nome dos estágios",
            add_Date: "Data de adição",
            add: "Adicionar estágio",
            edit: "Editar estágio",
            if: "Se",
            ranges: "intervalos",
            and: "e",
            enter1: "Inserir intervalo 1",
            enter2: "Inserir intervalo 2",
            del: "Eliminar estágio",
            then: "Então",
            update: "Atualizar",
            add: "Adicionar",
          },
          utm: {
            title: "Variáveis de campanha UTM",
            text: "Acompanhe a origem e o meio das suas campanhas de inquérito para obter melhores insights e análise de dados.",
            campaign: "Campanha",
            medium: "Meio",
            source: "Fonte",
            text1:
              "Tem a certeza que deseja eliminar permanentemente a variável UTM?",
            add: "+ Adicionar",
          },
          builder: {
            title: "Construtor de formulários",
            edit: "Editar",
            preview: "Pré-visualizar",
            add: "Adicionar campo",
            required: "Obrigatório",
            delete: "Eliminar campo",
            edit1: "Editar campo",
            save: "Guardar",
            hidden: "Entrada oculta",
            textfield: "Campo de texto",
            area: "Área de texto",
            email: "Email",
            drop: "Desdobrável",
            num: "Número de telefone",
            check: "Caixas de seleção",
            radio: "Botões de rádio",
            hidden1: "Oculto",
            labelField: "Rótulo",
            name: "Nome",
            label: "Rótulo",
            value: "Valor padrão",
            place: "Espaço reservado",
            option: "Opções",
            addOptions: "Adicionar opção",
            optionMinRequired: "É necessária pelo menos uma opção e não pode ser eliminada",
            editLabel: "Editar rótulo",
            labelContent: "Conteúdo",
            labelContentPlaceholder: "Insira o conteúdo HTML do rótulo",
            editButton: "Editar botão",
            goAhead: "Prossiga",
            alignment: "Alinhamento",
            text12:
              "Sim, desejo receber marketing da Vodafone Limited sobre os seus produtos e últimas ofertas",
            btnText: "Texto do botão",
            center: "Centro",
            left: "Esquerda",
            right: "Direita",
            "edit_t&c": "Editar T&C",
            add_heading: "Adicionar cabeçalho",
            add_description: "Adicionar descrição",
            submit: "Submeter",
            maxLength: "Comprimento máximo",
            enter_max_length: "Digite o comprimento máximo",
            only_numbers: "Apenas números",
            bannerImage: "Imagem do banner",
            bannerImageHelp: "Por favor, carregue uma imagem até 5 MB de tamanho, com dimensões de 951 × 875 pixels.",
            bannerUploadSuccess: "Imagem do banner carregada com sucesso",
            bannerUploadFailed: "Falha ao carregar imagem do banner",
            bannerSizeError: "Por favor, carregue uma imagem até 5MB",

            privacyHeading: "Cabeçalho de privacidade",
            option1: "Opção 1",
            option2: "Opção 2",
            option: "Opção",
            businessValidation: "Validação de e-mail empresarial",
          },
          report: {
            title: "Relatório",
            title1: "Construtor de relatórios",
            create: "Criar relatório",
            new: "Criar novo",
            scratch: "Criar novo relatório do zero",
            template1: "Modelo de relatório 1",
            text1: "Será descarregado após a conclusão do inquérito",
            recently: "Editado recentemente",
            no: "Nenhum relatório editado recentemente encontrado.",
            temp_name: "Nome do modelo",
            duplicate: "Duplicar",
            delete: "Eliminar",
            make: "Definir como padrão",
            del1: "Tem a certeza que deseja eliminar a página?",
            del2: "Eliminar página",
            saver: "Guardar relatório",
            showPage6: "Mostrar página de avaliação",
          },

          leadErasure: {
            title: "Regras de eliminação de leads",
            add_rule: "Adicionar regra",
            edit_rule: "Editar regra",
            col_type: "Tipo",
            col_description: "Descrição",
            col_status: "Estado",
            col_actions: "Ações",
            no_rules: "Nenhuma regra de eliminação de leads configurada.",
            rule_type: "Tipo de regra",
            field: "Campo",
            utm_field: "Campo UTM",
            operator: "Operador",
            value: "Valor",
            keep_strategy: "Estratégia de retenção",
            active: "Ativo",
            select_field: "Selecionar um campo...",
            enter_value: "Inserir valor...",
            enter_days: "Inserir número de dias...",
            starts_with_hint: "Separar múltiplos prefixos por vírgula, ex. 4,7,8",
            regex_hint: "Insira uma expressão regular válida no estilo JavaScript (avançado).",
            regex_pattern_label: "Padrão",
            regex_custom_pattern: "Padrão personalizado",
            enter_regex_placeholder: "ex.: ^[A-Z]{2}\\d+$",
            regex_preset: {
              custom: "Personalizado (avançado)",
              letters_only: "Apenas letras (A–Z, a–z)",
              digits_only: "Apenas algarismos (0–9)",
              exactly_9_chars: "Exatamente 9 caracteres",
              nine_same_character: "Os 9 caracteres iguais (ex.: 111111111)",
              eight_plus_same_digits: "8+ algarismos iguais consecutivos",
            },
            edit: "Editar",
            delete: "Eliminar",
            created: "Regra criada com sucesso.",
            updated: "Regra atualizada com sucesso.",
            deleted: "Regra eliminada com sucesso.",
            errors: {
              field_required: "Por favor selecione um campo.",
              operator_required: "Por favor selecione um operador.",
              value_required: "Por favor insira um valor.",
              days_invalid: "Por favor insira um número de dias válido (superior a 0).",
              regex_invalid: "Expressão regular inválida. Verifique o padrão e tente novamente.",
            },
          },

          share: {
            tittle: "Publicar & partilhar",
            text1: "Como gostaria de partilhar o inquérito com as pessoas?",
            copy: "Copiar ligação",
            campaign: "URLs de campanha",
            create: "Criar novo URL",
            name: "Nome",
            res: "Respostas",
            createdDate: "Data de criação",
            status: "Estatuto",
            action: "Ação",
            name: "Nome",
            source: "Fonte",
            medium: "Meio",
            content: "Conteúdo",
            campaign: "Campanha",
            Parameters: "Adicionar parâmetros",
            add: "Adicionar",
            cancle: "Cancelar",
            update: "Atualizar",
            url: "URL UTM gerado",
            text2:
              "Preencha os campos no formulário abaixo para adicionar parâmetros ao URL do seu inquérito. Para obter automaticamente informações a partir da sua ligação partilhada, clique em cada campo e selecione um parâmetro dinâmico como placement = `` .",
            edit1: "Editar URL de campanha",
            text2:
              "Este é o nome do seu esforço de marketing. Em suma, o nome da sua campanha, por exemplo, promoção, venda, etc.",
            del1: "Tem a certeza que deseja eliminar",
          },
          groups: {
            menu: "Grupo de inquéritos",
            title: "Grupos de inquéritos",
            heading: "Um link. Todos os idiomas.",
            share: "Partilhar grupo de pesquisa",
            group: "Grupos",
            removeGroup: "Remover do grupo",
            addTOGroup: "Adicionar ao grupo",
            makePrimary: "Torne-o primário",
            caption: "Agrupe inquéritos localizados, defina uma experiência primária e partilhe um único URL com troca automática de idioma.",
            createBtn: "Criar grupo",
            createTitle: "Criar grupo de inquéritos",
            manageTitle: "Gerir grupo de inquéritos",
            groupName: "Nome do grupo",
            selectSurvey: "Adicionar inquérito",
            selectPlaceholder: "Selecionar inquérito para incluir",
            addToGroup: "Adicionar ao grupo",
            noSurveysSelected: "Nenhum inquérito selecionado ainda.",
            primary: "Primário",
            untitledSurvey: "Inquérito sem título",
            untitledGroup: "Grupo sem título",
            loading: "A carregar detalhes do grupo...",
            delete: "Eliminar grupo",
            saveDetails: "Guardar detalhes",
            saveOrdering: "Guardar ordenação",
            langConflict: "Um inquérito com este idioma já existe no grupo.",
            selectAll: "Selecionar todos",
            languageRestriction: "Pode selecionar apenas um inquérito para cada idioma",
            languageAlreadySelected: "Idioma já selecionado",
            totalSurveys: "Total de inquéritos",
            addedOnAddedBy: "Adicionado em / Por",
            rename: "Renomear",
            deleteGroup: "Eliminar grupo de inquéritos",
            deleteWarning: "Aviso!",
            deleteMessage: "Eliminar",
            deleteConfirmation: "irá removê-lo permanentemente. Esta ação não pode ser anulada.",
            areYouSure: "Tem a certeza que deseja eliminar este grupo de inquéritos?",
            renameGroup: "Renomear grupo",
            enterGroupName: "Introduza o nome do grupo",
            groupNamePlaceholder: "Introduza o novo nome do grupo",
            surveyGroup: "Grupo de inquéritos",
            individualSurvey: "Inquérito individual",
            home: "Início",
            responses: "Respostas",
            sections: "Seções",
            questions: "Questões",
            unknownSurvey: "Inquérito desconhecido",
            noLanguageCode: "Sem código de idioma",
            removeSurvey: "Eliminar inquérito",
            removeSurveyConfirm: "Tem a certeza de que deseja eliminar este inquérito do grupo?",
            removeSurveyWarning: "deste grupo irá desvinculá-lo. O inquérito permanecerá na sua lista de inquéritos.",
            noSurveysInGroup: "Ainda não há inquéritos neste grupo",
            surveyOrderUpdated: "Ordem do inquérito atualizada com sucesso",
            primarySurveyUpdated: "Inquérito primário atualizado com sucesso",
            surveysAddedSuccess: "inquérito(s) adicionado(s) ao grupo com sucesso",
            surveyRemovedSuccess: "Inquérito removido do grupo com sucesso",
            cannotAddDuplicateLanguages: "Não é possível adicionar inquéritos com idiomas duplicados",
            failedToAddSurveys: "Falha ao adicionar alguns inquéritos",
            pleaseSelectSurvey: "Por favor, selecione pelo menos um inquérito para adicionar",
            errors: {
              nameRequired: "O nome do grupo é obrigatório",
              surveyRequired: "Por favor, adicione pelo menos um inquérito",
              slugRequired: "O slug é obrigatório para links de grupo",
              languageConflict: "Um inquérito com este idioma já está selecionado"
            },
            toast: {
              created: "Grupo de inquéritos criado com sucesso",
              createError: "Falha ao criar grupo de inquéritos",
              memberAdded: "Inquérito adicionado ao grupo",
              memberRemoved: "Inquérito removido do grupo",
              orderSaved: "Ordenação atualizada",
              detailsSaved: "Detalhes do grupo guardados",
              deleted: "Grupo de inquéritos eliminado com sucesso",
              linkCreated: "Link do grupo criado",
              linkError: "Não foi possível criar o link",
              linkUpdated: "Link do grupo atualizado",
              renamed: "Grupo renomeado com sucesso",
              renameError: "Falha ao renomear grupo",
              deleteError: "Falha ao eliminar grupo",
              selectAtLeastOne: "Selecione pelo menos um inquérito para criar um grupo",
              languageDuplicateSkipped: "Alguns inquéritos foram ignorados devido a idiomas duplicados"
            },
            steps: {
              createTitle: "Criar grupos lógicos",
              createDesc: "Selecione os inquéritos localizados que pertencem juntos.",
              orderTitle: "Controlar ordem e primário",
              orderDesc: "Arraste para reordenar e definir a experiência de inquérito padrão.",
              publishTitle: "Publicar links multi-idioma",
              publishDesc: "Partilhe um URL e deixe os respondentes trocar de idioma."
            },
            table: {
              name: "Nome do grupo",
              languages: "{{count}} idiomas",
              primary: "Inquérito primário",
              updated: "Criado",
              actions: "Ações"
            },
            actions: {
              manage: "Editar",
              edit: "Editar",
              linkWorkspace: "Espaço de trabalho de links"
            },
            emptyState: "Ainda não há grupos de inquéritos. Crie o seu primeiro grupo para começar.",
            links: {
              heading: "URLs do grupo",
              subheading: "Gerir links para {{name}}",
              closeWorkspace: "Fechar espaço de trabalho",
              previewLabel: "Link base",
              previewPlaceholder: "A pré-visualização do URL do grupo aparecerá aqui",
              empty: "Ainda não foram criados links para este grupo."
            },
            slugLabel: "Slug do grupo",
            previewLabel: "Link base",
            previewPlaceholder: "Pré-visualização do URL do grupo",
            addToGroupBtn: "Adicionar inquérito selecionado"
          },
          question: {
            title: "Construtor de perguntas e respostas",
            multi: "Escolha múltipla",
            text: "Texto",
            scale: "Escala de opinião",
            q: "P",
            del1: "Eliminar pergunta",
            del2: "Tem a certeza de que quer eliminar a pergunta? Eliminar o tipo de pergunta resultará na eliminação de todos os dados relacionados com esta pergunta.",
            enter: "Por favor, introduza a pergunta",
            editq: "Editar pergunta",
            duplicateq: "Pergunta duplicada",
            recorder: "Reordenar pergunta",
            addq: "Adicionar pergunta",
            adds: "Adicionar secção",
            questions: "Questões",
            question: "Questõe",
            sections: "Seções",
            description: "Adicione aqui a descrição da sua pesquisa!",
            del_section1: "Apagar esta secção?",
            del_section2: "Selecione uma opção para continuar",
            del_section3: " Apague esta secção e junte as perguntas em",
            del_section4: "Apague esta secção com todas as suas perguntas.",
            next: "seguinte",
            previous: "anterior",
            texts: "O nome da pesquisa é obrigatório",
            edits: "Editar secção",
            duplicates: "Secção duplicada",
            recorders: "Secção de reordenar",
            deletes: "Apagar seção",
          },
          sidebar: {
            email_templates: "Modelos de email",
            webhooks: "Webhooks",
            cookie_policy: "Política de cookies",
          },
          email_template: {
            breadcrumb: "Modelo de email",
            page_title: "Editor de modelo de email",
            email_subject: "Assunto do email",
            subject_placeholder: "O seu relatório está pronto",
            email_enabled: "Email ativado",
            email_disabled: "Email desativado",
            reset_to_default: "Repor predefinições",
            saving: "A guardar...",
            save_template: "Guardar modelo",
            toast_enabled: "Email de relatório ativado",
            toast_disabled: "Email de relatório desativado",
            toast_saved: "Modelo de email guardado",
            toast_reverted: "Revertido para o modelo de email predefinido",
            toast_copied: "Copiado {{text}} — cole em qualquer campo de texto",
            toast_copy_fallback: "Copie isto: {{text}}",
            click_to_copy: "Clique para copiar",
            section_general: "Geral",
            section_heading: "Título",
            section_description: "Descrição",
            section_button: "Botão",
            section_notes: "Notas e assistência",
            section_signoff: "Despedida",
            section_footer: "Rodapé",
            section_placeholders: "Marcadores",
            label_email_bg: "Fundo email",
            label_card_bg: "Fundo cartão",
            label_font: "Tipo de letra",
            label_padding: "Espaçamento",
            label_color: "Cor",
            label_font_size: "Tamanho da letra",
            label_bg_color: "Cor de fundo",
            label_text_color: "Cor do texto",
            label_section_bg: "Fundo da secção",
            label_radius: "Raio",
            label_height: "Altura",
            label_width: "Largura",
            label_border: "Borda",
            label_security_note: "Nota de segurança",
            label_assistance_note: "Nota de assistência",
            placeholder_desc: "Clique num marcador para o copiar, depois cole em qualquer campo de texto na pré-visualização. Estes são <strong>opcionais</strong> &mdash; se remover um, esse valor simplesmente não aparecerá no email enviado.",
            placeholder_org_name: "Nome de exibição da organização (ex.: \"Vodafone Support\")",
            placeholder_support_email: "Endereço de email de suporte (ex.: \"support@vodafone.com\")",
            placeholder_report_url: "Ligação para o relatório gerado (inserido automaticamente no botão)",
            reset_title: "Repor predefinições",
            reset_warning: "Isto irá reverter o modelo de email para o seu estado predefinido. Todas as suas personalizações (texto, cores, estilos) serão permanentemente perdidas.",
            reset_confirm: "Sim, repor",
            reset_cancel: "Cancelar",
          },
          cookie_policy_page: {
            breadcrumb: "Política de cookies",
            page_title: "Política de cookies",
            page_description: "Gerir o conteúdo da política de cookies para este inquérito. Alternar a visibilidade no rodapé do inquérito.",
            show_in_footer: "Mostrar política de cookies no rodapé do inquérito",
            enabled: "Ativado",
            disabled: "Desativado",
            banner_settings: "Configurações dos botões do banner de cookies",
            accept_button: "Botão aceitar",
            reject_button: "Botão rejeitar",
            show: "Mostrar",
            hidden: "Oculto",
            button_text_label: "Texto do botão (deixe vazio para tradução predefinida)",
            accept_placeholder: "ex.: Aceitar todos os cookies",
            reject_placeholder: "ex.: Rejeitar todos",
            saving: "A guardar...",
            save: "Guardar",
          },
        },
        analytics: {
          title: "Análise",
          heading: "Análise",
          select: "Selecionar inquérito",
          text1: "Ver tudo",
          select_survey: "Selecionar inquérito",
          date: "Data",
          completion_analysis: "Análise de conclusão",
          maturity_analysis: "Análise de maturidade",
          question_wise: "Por pergunta",
          exits_analysis: "Análise de saídas",
          last_month: "Mês passado",
          last7: "Últimos 7 dias",
          this: "Este mês",
          last30: "Últimos 30 dias",
          notAns: "Não respondido",
          complete: "Completa",
          inComplete: "Incompleta",
          question: "Questões",
          respondentCount: "Contagem de entrevistados",
          surveyCount: "Contagem de pesquisas",
          today: "Hoje",
          yesterday: "ontem",
          all: "Tudo",
          link: "Ligação",
          utm_source: "Fonte UTM",
          utm_medium: "Meio UTM",
          utm_campaign: "Campanha UTM",
          del1: "Apagar este lead irá removê-lo permanentemente do sistema. Tem a certeza de que quer continuar?",
          del2: "Apagar lead",
          del3: "Apagar leads selecionados",
          del4: "leads selecionados? Esta ação não pode ser anulada.",
          TANDC: "Preferências de marketing",

          top_10_leads: {
            heading: "Os 10 principais leads gerados",
            description:
              "Apresenta detalhes dos 10 principais leads gerados. Clique em qualquer coluna para ordenar os dados. Exporte para Excel para uma análise detalhada.",
          },
          date_of_survey: "Data do inquérito",
          report_link: "Ligação do relatório",
          first_name: "Primeiro nome",
          last_name: "Apelido",
          email_address: "Endereço de email",
          phone_number: "Número de telefone",
          organization_name: "Nome da organização",
          industry: "Indústria",
          number_of_responses: "Nº de respostas",
          maturity_level: "Nível de maturidade",
          total_score: "Pontuação total",
          completed: "Concluído",
          unique_id: "ID único",
          tab_all: "Todos",
          tab_archived: "Arquivado",
          archived_by_rule: "Arquivado pela regra",
          delete_permanently: "Eliminar permanentemente",
          totals: {
            total_survey_responses: "Total de respostas ao inquérito",
            completed_surveys: "Inquéritos concluídos",
            completed_leads: "Leads concluídos",
          },
        },
        settings: {
          title: "Configurações",
          general: "Configurações gerais",
          general_breadcrumb: "Configurações gerais",
          account_settings: {
            heading: "Perfil",
            email: "E-mail",
            user_name: "Nome do utilizador",
            country: "País",
            region: "Região",
            timezone: "Fuso horário",
            save_changes: "Guardar alterações",
            default_language: "Idioma padrão",
            assignTeamRole: "Equipas e funções atribuídas",
          },
          security: "Segurança",
          ticket_notifications: "Notificações",
          organization_details: {
            heading: "Detalhes da organização",
            breadcrumb_heading: "Detalhes da organização",
            privacy_policy: "Política de privacidade",
            terms_of_use: "Termos de uso",
            cookie_policy: "Política de cookies",
          },
          users_and_teams: {
            heading: "Gestão de utilizadores",
            breadcrumb_heading: "Gestão de utilizadores",
            users: {
              heading: "Utilizadores",
              sub_heading:
                "Gerir o acesso ao produto para todos os utilizadores na sua organização.",
              search: "Pesquisa",
              name: "Nome",
              action: "Ação",
              edit_action: {
                edit_user: "Editar utilizador",
                full_name: "Nome completo",
                email_address: "Endereço de e-mail",
                password: "Palavra-passe",
                cancel: "Cancelar",
                save: "Guardar",
                recently: "Adicionado recentemente",
                sorta: "Classificar A-Z",
                sortb: "Classificar Z-A",
              },
              delete_action: {
                heading: "Eliminar utilizadores",
                sub_heading: "Aviso",
                cancel: "Cancelar",
                confirm_delete: "Confirmar eliminação",
                text1:
                  "Tem a certeza que deseja eliminar permanentemente estes utilizadores?",
                text2:
                  "Ao eliminar os utilizadores, irá removê-los de todos os Inquéritos e eliminar as suas permissões de acesso.",
              },
              create_user: {
                heading: "Criar utilizador",
                full_name: "Nome completo",
                email_address: "Endereço de e-mail",
                password: "Palavra-passe",
                cancel: "Cancelar",
                save: "Guardar",
                enter: "Introduzir",
              },
            },
          },
          roles: {
            heading: "Funções",
            description:
              "As funções são conjuntos de permissões e responsabilidades predefinidos que são atribuídos.",
            common: {
              role_name: "Nome da função",
              select_parent_role: "Selecionar função principal",
              permissions: {
                heading: "Permissões",
                survey: "Inquérito",
                analytics: "Análise",
                users: "Utilizadores",
                roles: "Funções",
                teams: "Equipas",
                actions: {
                  view: "Ver",
                  write: "Escrever",
                  read: "Ler",
                  delete: "Eliminar",
                },
              },
              cancel: "Cancelar",
              save: "Guardar",
            },
            create_role: {
              heading: "Criar função",
              add_new: "Adicionar nova",
              role: "Função",
              edit: "Editar",
            },
            role_list: {
              sr_no: "Nº",
              name: "Nome",
              date_added: "Data de adição",
              action: "Ação",
            },
            edit_action: {
              edit_role: "Editar função",
            },
            delete_action: {
              heading: "Eliminar funções",
              sub: "Excluir função",
              sub_heading:
                "Ao eliminar a função de utilizador, estará a removê-la de todos os Servidores e a eliminar as suas permissões de acesso.",
              cancel: "Cancelar",
              delete: "Eliminar",
            },
          },
          team: {
            heading: "Equipas",
            description:
              "As equipas são grupos de utilizadores que trabalham juntos em projetos ou tarefas específicas.",
            create_team: {
              heading: "Criar equipa",
              team_name: "Nome da equipa",
              save: "Guardar",
              cancel: "Cancelar",
              member: "Membros",
            },
            action: {
              edit: "Editar",
              edit_team: "Editar equipa",
              team_name: "Nome da equipa",
              save: "Guardar",
              cancel: "Cancelar",
              add_member: "Adicionar membro",
              select_role: "Selecionar função",
              added_members: "Membros adicionados",
              leave: "Sair",
              owner: "Proprietário",
              delete: {
                heading: "Eliminar equipa",
                warning: "Aviso",
                text: "Ao eliminar esta equipa, irá eliminar todos os membros da equipa e as informações relacionadas.",
                cancel: "Cancelar",
                confirm_delete: "Confirmar eliminação",
              },
            },
            sort_by: "Ordenar por",
          },
          integration: {
            tittle: "Integração",
            text: "Você pode fazer uma ponte entre o formulário eloqua e o formulário de avaliação.",
            eloqua: "Elóqua",
            save: "Salvar",
            formURL: "URL do formulário",
            companyName: "Nome da empresa",
            userName: "Nome de usuário",
            password: "Senha",
            settings: "Configurações",
          },
          questionnaire: {
            title: "Questionário",
            "assessments​": "Avaliações​",
            pageHeading: "Título da página",
            buttontext: "Texto do botão",
            buttonNextText: "Texto do botão",
            buttonHeadingText: "cabeçalho do botão",
            save: "Salvar",
            buttonBack: "Botão voltar",
            reportPageHeading: "Título da página do relatório",
            reportHeading: "Título do relatório",
            stage: "Estágio",
            stage1: "Estágio 1",
            stage2: "Estágio 2",
            stage3: "Estágio 3",
            stage4: "Estágio 4",
            stage5: "Estágio 5",
            report: "Relatório",
            hint: "Por favor insira a dica",
            choice: "Escolha",
          },
          thankyouPage: {
            title: "Página de agradecimento",
            pageDescription: "Descrição da página",
            buttonText1: "Visualização de botão",
            buttonText2: "Baixar botão",
          },
          CustomVairable: {
            linkCustom: "Vincular uma variável personalizada",
            variableLabel: "Rótulo da variável",
            variableName: "Nome da variável",
            value: "Valor",
            action: "Ação",
            noDataFound: "Nenhum dado encontrado",
            editVariable: "Editar variável",
            addVariable: "Adicionar variável",
            deleteVariable: "Excluir variável",
            enterValue: "Digite o valor",
            cancel: "Cancelar",
            save: "Salvar",
            loading: "Carregando...",
            confirmDelete: "Confirmar exclusão",
            areYouSure: "Tem certeza de que deseja excluir a variável?",
            addSection: "Adicionar seção",
            editSection: "Editar seção",
            duplicateSection: "Duplicar seção",
            reorderSection: "Reordenar seção",
            deleteSection: "Excluir seção",
            selectVariable: "Selecionar variável",
            newchoices: "Adicione novas opções",
            score: "Pontuação",
            variable: "Variável",
            select: "Selecione",
          },
          save_changes: "Guardar alterações",
          loading: "A carregar...",
          loading_settings: "A carregar configurações...",
          security_settings: {
            title: "Configurações de segurança",
            description: "Configurar a segurança de login para todos os utilizadores.",
            sso_title: "Microsoft SSO",
            sso_description: "Permitir que os utilizadores iniciem sessão usando a sua conta Microsoft (Azure AD). Quando desativado, o botão \"Iniciar sessão com a Microsoft\" será ocultado da página de login.",
            mfa_title: "Autenticação multifator (MFA)",
            mfa_description: "Quando ativada, os utilizadores devem verificar a sua identidade com um código de 6 dígitos enviado para o e-mail após inserir a palavra-passe. O código expira após 10 minutos.",
            lockout_title: "Bloqueio de conta",
            lockout_description: "Bloquear automaticamente as contas de utilizadores após múltiplas tentativas de login falhadas para prevenir ataques de força bruta.",
            max_attempts: "Máximo de tentativas falhadas",
            lock_duration: "Duração do bloqueio",
            minutes: "minutos",
            password_expiry_title: "Expiração da palavra-passe",
            password_expiry_description: "Forçar os utilizadores a alterar a palavra-passe após um número definido de dias. Os utilizadores serão redirecionados para uma página de redefinição de palavra-passe ao iniciar sessão se a palavra-passe tiver expirado.",
            expire_after: "Expirar após",
            disabled: "Desativado",
            days: "dias",
            success: "Configurações de segurança atualizadas com sucesso",
            error: "Falha ao atualizar configurações",
          },
          ticket_notification_settings: {
            title: "Configurações de notificação de tickets",
            description: "Selecione os utilizadores que devem receber notificações por e-mail quando um novo ticket é criado ou um ticket é atribuído.",
            recipients_title: "Destinatários de notificações por e-mail",
            recipients_description: "Estes utilizadores receberão um e-mail sempre que um ticket for criado (por um utilizador ou automaticamente pelo sistema). Além disso, quando um ticket é atribuído a um utilizador, esse utilizador receberá um e-mail de notificação de atribuição.",
            add_users: "Adicionar utilizadores",
            search_placeholder: "Pesquisar utilizadores por nome ou e-mail...",
            no_users: "Nenhum utilizador selecionado. Pesquise e adicione utilizadores acima.",
            remove: "Remover",
            success: "Destinatários de notificações atualizados com sucesso",
            error: "Falha ao atualizar destinatários",
          },
          organization_details_page: {
            edit_description: "Editar o conteúdo de {{title}} apresentado na página de login.",
            success: "{{title}} atualizado com sucesso",
            error: "Falha ao atualizar",
          },
          editor: {
            bold: "Negrito",
            italic: "Itálico",
            underline: "Sublinhado",
            bulleted_list: "Lista com marcadores",
            numbered_list: "Lista numerada",
            link: "Ligação",
            table: "Tabela",
            text_color: "Cor do texto",
            color: "Cor",
            no_color: "Sem cor",
            url_prompt: "URL",
          },
        },
        tickets: {
          title: "Tickets",
          create_ticket: "+ Criar ticket",
          search_placeholder: "Pesquisar tickets...",
          no_tickets: "Nenhum ticket encontrado",
          created_success: "Ticket criado com sucesso",
          view: "Ver",
          view_details: "Ver detalhes do ticket",
          dashboard: {
            open: "Aberto",
            acknowledged: "Reconhecido",
            in_progress: "Em progresso",
            resolved: "Resolvido",
            total: "Total",
          },
          status: {
            open: "Aberto",
            acknowledged: "Reconhecido",
            in_progress: "Em progresso",
            resolved: "Resolvido",
            false_positive: "Falso positivo",
          },
          alert_type: {
            brute_force: "Força bruta",
            unauthorized_token: "Token não autorizado",
            unknown_user: "Utilizador desconhecido",
            inactive_user: "Utilizador inativo",
            suspicious_ip: "IP suspeito",
            after_hours: "Fora de horário",
            manual: "Manual",
          },
          columns: {
            title: "Título",
            type: "Tipo",
            severity: "Gravidade",
            status: "Estado",
            source: "Origem",
            assigned_to: "Atribuído a",
            created: "Criado",
            action: "Ação",
          },
          filters: {
            all_statuses: "Todos os estados",
            all_severities: "Todas as gravidades",
            all_sources: "Todas as origens",
            all_assignees: "Todos os atribuídos",
            unassigned: "Não atribuído",
          },
          severity: {
            low: "Baixa",
            medium: "Média",
            high: "Alta",
            critical: "Crítica",
          },
          source: {
            system: "Sistema",
            user: "Utilizador",
          },
          create: {
            title: "Criar ticket",
            title_label: "Título *",
            title_placeholder: "Breve descrição do problema",
            title_required: "O título é obrigatório",
            title_max: "O título deve ter 255 caracteres ou menos",
            severity_label: "Gravidade *",
            severity_required: "A gravidade é obrigatória",
            severity_placeholder: "Selecionar gravidade...",
            description_label: "Descrição",
            description_max: "A descrição deve ter 2000 caracteres ou menos",
            description_placeholder: "Forneça detalhes adicionais...",
            assign_to: "Atribuir a",
            unassigned: "Não atribuído",
            cancel: "Cancelar",
            creating: "A criar...",
            submit: "Criar ticket",
          },
          detail: {
            back: "Voltar aos tickets",
            not_found: "Ticket não encontrado.",
            status: "Estado",
            severity: "Gravidade",
            alert_type: "Tipo de alerta",
            source: "Origem",
            ip_address: "Endereço IP",
            raised_by: "Criado por",
            assigned_to: "Atribuído a",
            created: "Criado",
            resolved: "Resolvido",
            resolved_by: "por {{name}}",
            comments: "Comentários ({{count}})",
            no_comments: "Ainda sem comentários.",
            unknown_user: "Desconhecido",
            add_comment_placeholder: "Adicionar um comentário...",
            posting: "A publicar...",
            post_comment: "Publicar comentário",
            update_status: "Atualizar estado",
            updating: "A atualizar...",
            assign_to: "Atribuir a",
            select_user: "Selecionar utilizador...",
            assigning: "A atribuir...",
            assign_btn: "Atribuir",
            status_updated: "Estado atualizado",
            status_update_failed: "Falha ao atualizar o estado",
            assigned: "Ticket atribuído",
            assign_failed: "Falha ao atribuir o ticket",
            comment_added: "Comentário adicionado",
            comment_failed: "Falha ao adicionar comentário",
          },
        },

        documentation: {
          ...docTranslations.pt.documentation,
          title: "Documentação",
        },
        activityLog: {
          title: "Registo de atividade",
          message: "Mensagem",
          action: "Ação",
          added_by: "Adicionado por",
          date_time: "Data e hora",
        },

         privacyPolicy: {
          heading: "Política de privacidade",
          title: "Configure ou anexe sua política de privacidade da pesquisa aqui."
        },
        webhook: {
          url: "URL",
          title: "webhook",
          webhook: "webhook",
          createTitle: "Criar novo webhook",
          editTitle: "Editar webhook",
          name: "Insira o nome",
          event: "Eventos",
          add: "Adicionar webhook",
          desc: "Insira a descrição",
          active: "Ativo",
          inactive: "Inativo",
          generateURl: "URL do webhook gerado",
          delete: "Excluir webhook",
          delete1:
            "Excluir este webhook desativará seus gatilhos para todos os eventos associados. Esta ação não pode ser desfeita. Tem certeza?",
          recently: "Adicionado recentemente",
          example: "https\\:exemplo4.com",
          remove: "Remover",
          assign: "Atribuir equipa",
          method: "Método*",
          content_type: "Tipo de conteúdo*",
          data_format: "Formato de dados*",
          parameters: "Parâmetros*",
          preview: "Pré-visualização",

          validation: {
            name_required: "O nome é obrigatório",
            url_required: "O URL é obrigatório",
            url_invalid: "URL inválido",
            event_required: "O evento é obrigatório",
            http_method_required: "O método HTTP é obrigatório",
            http_method_oneof: "Método HTTP inválido",
            content_type_required: "O tipo de conteúdo é obrigatório",
            data_format_required: "O formato de dados é obrigatório",
            data_format_invalid: "Formato de dados inválido",
            params_name_required: "O nome é obrigatório",
            params_value_required: "O valor é obrigatório",
            get_no_body:
              "As solicitações GET não podem ter corpo. Por favor, utilize Parâmetros de Query para solicitações GET.",
          },
        },
        sync: {
          syncFromUat: "Sincronizar do UAT",
          versionHistory: "Histórico de versões",
          survey: "Inquérito",
          mode: "Modo",
          fullReplacement: "Substituição completa",
          merge: "Fundir",
          cancel: "Cancelar",
          next: "Seguinte",
          loading: "A carregar...",
          sync: "Sincronizar",
          syncing: "A sincronizar...",
          close: "Fechar",
          acceptAndSync: "Aceitar e sincronizar",
          merging: "A fundir...",
          loadingSurveys: "A carregar inquéritos...",
          noSurveysFound: "Nenhum inquérito encontrado.",
          fullReplacementNote: "Uma versão de snapshot será criada antes da substituição para permitir reversão se necessário.",
          mergeNote: "Clique em Seguinte para ver novos itens e conflitos. A versão UAT será usada para conflitos.",
          noteLabel: "Nota:",
          mergeModeLabel: "Modo de fusão:",
          showLatestVersions: "Mostrar apenas as últimas 5 versões",
          version: "Versão",
          type: "Tipo",
          date: "Data",
          action: "Ação",
          loadingVersions: "A carregar versões...",
          beforeRestore: "Antes de restaurar",
          beforeRestoreToVersion: "Antes de restaurar para a Versão",
          beforeMerge: "Antes de fundir do UAT",
          beforeSync: "Antes de sincronizar do UAT",
          restoring: "A restaurar...",
          restore: "Restaurar",
          noVersionsFound: "Nenhuma versão encontrada.",
          mergePreview: "Pré-visualização de fusão",
          conflictsWarning: "Conflitos",
          conflictsDescription: "Mesmo UUID, conteúdo diferente. A versão UAT irá substituir a Primária.",
          newItems: "Novos itens",
          duplicatesWarning: "Duplicados",
          duplicatesDescription: "UUID diferente, mesmo conteúdo. Ambas as versões serão mantidas.",
          noChanges: "Sem alterações para fundir. O inquérito já está sincronizado.",
          new: "Novo",
          conflicts: "Conflitos",
          duplicates: "Duplicados",
          questions: "Perguntas",
          sections: "Secções",
          variables: "Variáveis",
          leadGenVariables: "Variáveis lead gen",
          utmVariables: "Variáveis UTM",
          customFormulas: "Fórmulas personalizadas",
          stages: "Fases",
          reportPages: "Páginas de relatório",
          customVariableValues: "Valores de variáveis personalizadas",
          reports: "Relatórios",
          surveyLinks: "Links de inquérito",
          webhooks: "Webhooks",
          privacyPolicy: "Política de privacidade",
          questionnaire: "Questionário",
          thankYouPage: "Página de agradecimento",
          toast: {
            linkCopied: "Link copiado para a área de transferência",
            invalidVersionSelected: "Versão inválida selecionada",
            restoredSuccess: "Restaurado para v{{version}}! Backup v{{backup}} criado.",
            restoreFailed: "Falha ao restaurar versão",
            noSurveySelected: "Nenhum inquérito selecionado para sincronizar",
            syncCompletedWithBackup: "Sincronização concluída! Versão v{{version}} criada como backup.",
            surveySyncedSuccess: "Inquérito sincronizado com sucesso",
            fullReplacementFailed: "Falha na substituição completa",
            clickPreviewFirst: "Por favor clique em Seguinte para ver as alterações antes de fundir",
            previewFailed: "Falha na pré-visualização",
            mergeCompletedSuccess: "Fusão concluída com sucesso",
            mergeFailed: "Falha na fusão",
            surveyDuplicatedSuccess: "Inquérito duplicado com sucesso",
            surveyDuplicateFailed: "Falha ao duplicar inquérito. Por favor tente novamente.",
            surveyDeletedSuccess: "Inquérito eliminado com sucesso",
            surveyDeleteFailed: "Falha ao eliminar inquérito. Por favor tente novamente.",
            selectSurveyToSync: "Por favor selecione um inquérito para sincronizar.",
            fetchUatSurveysFailed: "Falha ao carregar inquéritos UAT",
            noGroupSelected: "Nenhum grupo selecionado.",
            noSurveysSelectedToAdd: "Nenhum inquérito selecionado para adicionar.",
            surveysAddedToGroup: "{{count}} inquérito(s) adicionado(s) a {{groupName}} com sucesso.",
            duplicateLanguagesWarning: "Não é possível adicionar inquéritos com idiomas duplicados ao mesmo grupo",
            failedToAddSurveys: "Falha ao adicionar alguns inquéritos",
          },
        },
      },
    },
    sq: {
  translation: {
    dashboard: {
      title: "Paneli",
    },
    survey: {
      title: "Pyetësori",
      heading1: "Lista e pyetësorëve",
      heading: "Pyetësorë",
      status: "Statusi",
      published: "Publikuar",
      draft: "Draft",
      search: "Kërko pyetësorin tënd",
      all: "Të gjitha",
      duplicate: "Dyfisho pyetësorin",
      createSurvey: "Krijo pyetësor",
      surveyName: "Emri i pyetësorit",
      completionResponses: "Përfundimi / përgjigjet",
      addedOnAddedBy: "Shtuar në / Shtuar nga",
      lastModified: "Modifikimi i fundit",
      publishedOn: "Publikuar në",
      allL: "Të gjithë pyetësorët",
      export: "Eksporto në excel",
      create1: "A jeni gati të krijoni pyetësorin tuaj?",
      create2: "Në rregull, jam gati",
      create3: "Merr vetëm 2 minuta",
      ques2: "Cili është emri i pyetësorit tuaj?",
      next: "Tjetër",
      enter: "Shkruaj emrin e pyetësorit",
      del1: "Jeni i sigurt që dëshironi të largoheni nga ky pyetësor?",
      del2: "Lëre pyetësorin?",
      logout: "Dilni",
      editP: "Modifiko profilin",
      language: "Gjuha",
      assignTO: "Cakto te",
      select: "Zgjidh",
      ques3: "Jepni një përshkrim të shkurtër për pyetësorin",
      ques4: "Sa seksione keni në pyetësorin tuaj?",
      ques5: "Jepni emrat dhe përshkrimin e seksioneve tuaja",
      ques6: "Emrat e seksioneve",
      ques7: "Ju lutemi zgjidhni gjuhët që dëshironi në pyetësorin tuaj",
      questions: "Pyetje",
      sections: "Seksione",
      shareLink: "Shpërndaj linkun",
      SectionRequired: "Emri i seksionit është i nevojshëm",
      surveyRequire: "Përshkrimi i pyetësorit është i nevojshëm",
      numberRequire: "Numri i seksioneve është i nevojshëm",
      numberGreaterThanZero: "Numri duhet të jetë më i madh se 0",
      PleaseSelected: "Ju lutemi zgjidhni një gjuhë",
      enterNumber: "Shkruaj numrin",

      sectionTitle: "Titulli i seksionit",
      survey_description: "përshkrimi_i_pyetësorit",
      addDescription: "Shtoni përshkrimin e seksionit këtu",
      answerBe: "Përgjigjja duhet të jetë",
      change_type: "Ndrysho llojin",
      change_question_warning:
        "Jeni i sigurt që dëshironi të ndryshoni llojin e pyetjes? Ndryshimi i llojit të pyetjes do të rezultojë në fshirjen e të gjitha të dhënave të lidhura me këtë pyetje.",
      change_question_heading: "Ndrysho llojin e pyetjes?",
      headingR: "Rirendit seksionet",
      text: "Tekst",
      slider: "Rrëshqitës",
      multiple_choice: "Zgjedhje të shumta",
      opinion_scale: "Shkalla e opinionit",
      ranking: "Renditje",
      yes_or_no: "Po ose jo",
      custom_variables: "Variabla të personalizuar",
      error_info: "Ju lutemi shkruani detajet e pyetjes suaj",
      required: "E kërkuar",
      SurveyTitle: "Titulli i pyetësorit",
      lRequired: "Etiketa është e kërkuar",
      PRequired: "Placeholder është i kërkuar",
      NRequired: "Emri është i kërkuar",
      youCanNot: "Nuk mund ta fshini seksionin",

      actions: {
        editSurvey: "Modifiko pyetësorin",
        shareSurvey: "Shpërndaj pyetësorin",
        moveToDraft: "Kalo në draft",
        moveToPublish: "Kalo në publikim",
        viewLeads: "Shiko lidhjet",
        duplicate: "Dyfisho",
        delete: "Fshij",
      },
      variable: {
        heading: "Variabla",
        heading1: "Variabla të gjenerimit të lidhjeve",
        text1:
          "Variablat e Gjenerimit të Lidhjeve ofrojnë një mënyrë për të kapur dhe shfrytëzuar të dhënat nga një formular i Gjenerimit të Lidhjeve. Çdo fushë në formular i caktohet një emër unik, i cili mund të përdoret për të referuar dhe shfaqur vlerën përkatëse të fushës në raporte ose formula të personalizuara. Sintaksa për të aksesuar vlerën e një variable të gjenerimit të lidhjeve është #[leadForm:fieldName]#.",
        nodata: "Nuk u gjetën të dhëna",
      },

      customVariable: {
        customVariables: "Variabla të personalizuar",
        text1:
          "Variablat e Personalizuara ofrojnë një mënyrë për të caktuar vlera dinamike bazuar në kushtet e përcaktuara në modulin e Fazës. Këto variabla janë të pavarura dhe kanë emra unikë që mund të përdoren për të referuar dhe shfrytëzuar vlerat e tyre në të gjithë sistemin. Sintaksa për të aksesuar vlerën e një variable të personalizuar është #[fieldName]#.",
        label: "Etiketa",
        add_New_Variable: "Shto variabël të ri",
        type: "Lloji",
        varName: "Emri i variablit",
        action: "Veprimi",
        multi: "Tekst me shumë rreshta",
        single: "Tekst me një rresht",
        number: "Numër",
        name: "Emri",
        description: "Përshkrimi",
        cancel: "Anulo",
        del1: "Jeni i sigurt që dëshironi të",
        del2: "Fshini variablin e personalizuar",
        permanently: "përgjithmonë?",
        confirm_delete: "Konfirmo fshirjen",
        max_charaters: "Maks. 250 karaktere",
        no_spaces: "pa hapësira",
        edit_Variable: "Modifiko variablin",
        add: "Shto variabël",
        update: "Përditëso variablin",
      },

      customFormula: {
        custom_formula: "Formula e personalizuar",
        text1:
          "Formulat e Personalizuara ofrojnë një mënyrë për të caktuar vlera dinamike bazuar në kushtet e përcaktuara në modulin e Fazës. Këto variabla janë të pavarura dhe kanë emra unikë që mund të përdoren për të referuar dhe shfrytëzuar vlerat e tyre në të gjithë sistemin. Sintaksa për të aksesuar vlerën e një formule të personalizuar është #[fieldName]#.",
        add_New_formula: "Shto formulë të personalizuar",
        type: "Lloji",
        forName: "Formula",
        name: "Emri",
        description: "Përshkrimi",
        cancel: "Anulo",
        del1: "Jeni i sigurt që dëshironi të",
        del2: "Fshini formulën e personalizuar",
        permanently: "përgjithmonë?",
        confirm_delete: "Konfirmo fshirjen",
        max_charaters: "Maks. 250 karaktere",
        no_spaces: "pa hapësira",
        edit_formula: "Modifiko formulën",
        type_symbols: "Shkruani formulën tuaj duke përdorur simbolet -",
        with_variables: " me variabla.",
        delete: "Fshij linkun",
        edit: "Modifiko formulën",
        add: "Shto formulë",
        update: "Përditëso formulën",
        enterFormula: "Shkruaj formulën",
      },
      stages: {
        title: "Fazat",
        text: "Faza përfaqëson një nivel të ndryshëm të pjekurisë dhe progresit, bazuar në faktorë të tillë si njohuria dhe përvoja e teknologjisë së cloud-it, niveli i planifikimit dhe përgatitjes, dhe shkalla në të cilën kanë filluar procesin e migrimit në cloud.",
        stagesName: "Emri i fazave",
        add_Date: "Data e shtuar",
        add: "Shto fazë",
        edit: "Modifiko fazën",
        if: "Nëse",
        ranges: "intervalet",
        and: "dhe",
        enter1: "Shkruaj intervalin 1",
        enter2: "Shkruaj intervalin 2",
        del: "Fshij fazën",
        then: "Atëherë",
        update: "Përditëso",
      },
      utm: {
        title: "Variabla të fushatës UTM",
        text: "Gjurmo burimin dhe mediumin e fushatave tuaja të pyetësorit për njohuri më të mira dhe analizë të të dhënave.",
        campaign: "Fushata",
        medium: "Mediumi",
        source: "Burimi",
        text1: "Jeni i sigurt që dëshironi të fshini përgjithmonë variablin UTM?",
        add: "+ Shto",
      },
      builder: {
        title: "Ndërtuesi i formularit",
        edit: "Modifiko",
        preview: "Pamja paraprake",
        add: "Shto fushë",
        required: "E kërkuar",
        delete: "Fshij fushën",
        edit1: "Modifiko fushën",
        save: "Ruaj",
        hidden: "Input i fshehur",
        textfield: "Fushë teksti",
        area: "Zonë teksti",
        email: "Email",
        drop: "Meny rënëse",
        num: "Numri i telefonit",
        check: "Kutitë e zgjedhjes",
        radio: "Butonat radio",
        hidden1: "I fshehur",
        labelField: "Etiketë",
        name: "Emri",
        label: "Etiketa",
        value: "Vlera e paracaktuar",
        place: "Placeholder",
        option: "Opsionet",
        addOptions: "Shto opsion",
        optionMinRequired: "Kërkohet të paktën një opsion dhe nuk mund të fshihet",
        editLabel: "Modifiko etiketën",
        labelContent: "Përmbajtja",
        labelContentPlaceholder: "Shkruani përmbajtjen HTML të etiketës",
        editButton: "Modifiko butonin",
        goAhead: "Vazhdo",
        alignment: "Rreshtimi",
        text12:
          "Po, dëshiroj të marr marketing nga Vodafone Limited në lidhje me produktet tona dhe ofertat më të fundit",
        btnText: "Teksti i butonit",
        center: "Qendër",
        left: "Majtas",
        right: "Djathtas",
        "edit_t&c": "Modifiko T&C",
        add_heading: "Shto titull",
        add_description: "Shto përshkrim",
        submit: "Dërgo",
        maxLength: "Gjatësia maksimale",
        enter_max_length: "Shkruaj gjatësinë maksimale",
        only_numbers: "Vetëm numra",
        bannerImage: "Imazhi i bannerit",
        bannerImageHelp: "Ju lutemi ngarkoni një imazh deri në 5 MB në madhësi, me dimensione 951 × 875 pixels.",
        bannerUploadSuccess: "Imazhi i bannerit u ngarkua me sukses",
        bannerUploadFailed: "Dështoi ngarkimi i imazhit të bannerit",
        bannerSizeError: "Ju lutemi ngarkoni një imazh deri në 5MB",

        privacyHeading: "Titulli i privatësisë",
        option1: "Opsioni 1",
        option2: "Opsioni 2",
        option: "Opsioni",
        businessValidation: "Validimi i email-it të biznesit",
      },
      report: {
        title: "Raporti",
        title1: "Ndërtuesi i raporteve",
        create: "Krijo raport",
        new: "Krijo të ri",
        scratch: "Krijo raport të ri nga fillimi",
        template1: "Shabloni i raportit 1",
        text1: "Do të shkarkohet pas përfundimit të pyetësorit",
        recently: "Modifikuar kohët e fundit",
        no: " Nuk u gjetën raporte të modifikuara kohët e fundit.",
        temp_name: "Emri i shablonitit",
        duplicate: "Dyfisho",
        delete: "Fshij",
        make: "Bëje të paracaktuar",
        del1: "Jeni i sigurt që dëshironi të fshini faqen?",
        del2: "Fshij faqen",
        saver: "Ruaj raportin",
        showPage6: "Shfaq faqen e vlerësimit",
      },

      leadErasure: {
        title: "Rregullat e fshirjes së leads",
        add_rule: "Shto rregull",
        edit_rule: "Modifiko rregullin",
        col_type: "Lloji",
        col_description: "Përshkrimi",
        col_status: "Statusi",
        col_actions: "Veprimet",
        no_rules: "Nuk ka rregulla të fshirjes së leads të konfiguruara.",
        rule_type: "Lloji i rregullit",
        field: "Fusha",
        utm_field: "Fusha UTM",
        operator: "Operatori",
        value: "Vlera",
        keep_strategy: "Strategjia e mbajtjes",
        active: "Aktiv",
        select_field: "Zgjidhni një fushë...",
        enter_value: "Shkruaj vlerën...",
        enter_days: "Shkruaj numrin e ditëve...",
        starts_with_hint: "Ndani prefikset e shumëfishta me presje, p.sh. 4,7,8",
        regex_hint: "Shkruani një regex në stilin JavaScript (e avancuar).",
        regex_pattern_label: "Modeli",
        regex_custom_pattern: "Model i personalizuar",
        enter_regex_placeholder: "p.sh. ^[A-Z]{2}\\d+$",
        regex_preset: {
          custom: "Me porosi (e avancuar)",
          letters_only: "Vetëm shkronja (A–Z, a–z)",
          digits_only: "Vetëm shifra (0–9)",
          exactly_9_chars: "Saktësisht 9 karaktere",
          nine_same_character: "Të 9 karakteret identike (p.sh. 111111111)",
          eight_plus_same_digits: "8+ shifra të njëjta radhazi",
        },
        edit: "Modifiko",
        delete: "Fshij",
        created: "Rregulli u krijua me sukses.",
        updated: "Rregulli u përditësua me sukses.",
        deleted: "Rregulli u fshi me sukses.",
        errors: {
          field_required: "Ju lutemi zgjidhni një fushë.",
          operator_required: "Ju lutemi zgjidhni një operator.",
          value_required: "Ju lutemi shkruani një vlerë.",
          days_invalid: "Ju lutemi shkruani një numër të vlefshëm ditësh (më shumë se 0).",
          regex_invalid: "Regex e pavlefshme. Kontrolloni modelin dhe provoni përsëri.",
        },
      },

      share: {
        tittle: "Publiko & shpërndaj",
        text1: "Si do të dëshironit të ndani pyetësorin me njerëzit?",
        copy: "Kopjo linkun",
        campaign: "URL-të e fushatës",
        create: "Krijo URL të ri",
        name: "Emri",
        res: "Përgjigjet",
        createdDate: "Data e krijimit",
        status: "Statusi",
        action: "Veprimi",
        source: "Burimi",
        medium: "Mediumi",
        content: "Përmbajtja",
        campaign: "Fushata",
        Parameters: "Shto parametra",
        add: "Shto",
        cancle: "Anulo",
        update: "Përditëso",
        url: "URL-ja e gjeneruar UTM",
        text2:
          "Plotësoni fushat në formularin e mëposhtëm për të shtuar parametra në URL-në tuaj të pyetësorit. Për të marrë automatikisht informacion nga lidhja juaj e ndarë, klikoni në çdo fushë dhe zgjidhni parametër dinamik si vendosja = `` .",
        edit1: "Modifiko URL-në e fushatës",
        del1: "Jeni i sigurt që dëshironi të fshini",
        validation: "Ju lutemi plotësoni të gjitha fushat e kërkuara",
        linkCopied: "Linku u kopjua",
      },
      groups: {
        menu: "Grupi i pyetësorëve",
        title: "Grupet e pyetësorëve",
        heading: "Një link. Çdo gjuhë.",
        share: "Shpërndaj grupin e pyetësorit",
        group: "Grupet",
        removeGroup: "Hiq nga grupi",
        makePrimary: "Bëje primar",
        addTOGroup: "Shto në grup",
        caption: "Bashko pyetësorë të lokalizuar, vendos një përvojë primare dhe ndaj një URL të vetme me ndërrimin automatik të gjuhës.",
        createBtn: "Krijo grup",
        createTitle: "Krijo grup pyetësori",
        manageTitle: "Menaxho grupin e pyetësorit",
        groupName: "Emri i grupit",
        selectSurvey: "Shto pyetësor",
        selectPlaceholder: "Zgjidhni pyetësor për të përfshirë",
        addToGroup: "Shto në grup",
        noSurveysSelected: "Nuk ka pyetësorë të zgjedhur ende.",
        primary: "Primar",
        untitledSurvey: "Pyetësor pa titull",
        untitledGroup: "Grup pa titull",
        loading: "Duke ngarkuar detajet e grupit...",
        delete: "Fshij grupin",
        saveDetails: "Ruaj detajet",
        saveOrdering: "Ruaj renditjen",
        langConflict: "Një pyetësor me këtë gjuhë ekziston tashmë në grup.",
        selectAll: "Zgjidh të gjithë",
        languageRestriction: "Mund të zgjidhni vetëm një pyetësor për çdo gjuhë",
        languageAlreadySelected: "Gjuha është zgjedhur tashmë",
        totalSurveys: "Pyetësorët totalë",
        addedOnAddedBy: "Shtuar në / Shtuar nga",
        rename: "Riemërto",
        deleteGroup: "Fshij grupin e pyetësorëve",
        deleteWarning: "Paralajmërim!",
        deleteMessage: "Duke fshirë",
        deleteConfirmation: "do ta heqë përgjithmonë. Ky veprim nuk mund të zhbëhet.",
        areYouSure: "Jeni i sigurt që dëshironi të fshini këtë grup pyetësori?",
        renameGroup: "Riemërto grupin",
        enterGroupName: "Shkruani emrin e grupit",
        groupNamePlaceholder: "Shkruani emrin e ri të grupit",
        surveyGroup: "Grupi i pyetësorëve",
        individualSurvey: "Pyetësor individual",
        home: "Kryefaqja",
        responses: "Përgjigjet",
        sections: "Seksionet",
        questions: "Pyetjet",
        unknownSurvey: "Pyetësor i panjohur",
        noLanguageCode: "Asnjë kod gjuhe",
        removeSurvey: "Fshij pyetësorin",
        removeSurveyConfirm: "Jeni i sigurt që dëshironi të fshini këtë pyetësor nga grupi?",
        removeSurveyWarning: "nga ky grup do ta shkëputë. Vetë pyetësori do të mbetet në listën tuaj të pyetësorëve.",
        noSurveysInGroup: "Ende nuk ka pyetësorë në këtë grup",
        surveyOrderUpdated: "Renditja e pyetësorit u përditësua me sukses",
        primarySurveyUpdated: "Pyetësori primar u përditësua me sukses",
        surveysAddedSuccess: "pyetësorë(ë) u shtuan në grup me sukses",
        surveyRemovedSuccess: "Pyetësori u hoq nga grupi me sukses",
        cannotAddDuplicateLanguages: "Nuk mund të shtohen pyetësorë me gjuhë të dyfishta",
        failedToAddSurveys: "Dështoi shtimi i disa pyetësorëve",
        pleaseSelectSurvey: "Ju lutemi zgjidhni të paktën një pyetësor për të shtuar",
        errors: {
          nameRequired: "Emri i grupit është i kërkuar",
          surveyRequired: "Ju lutemi shtoni të paktën një pyetësor",
          slugRequired: "Slug është i kërkuar për lidhjet e grupit",
          languageConflict: "Një pyetësor me këtë gjuhë është zgjedhur tashmë"
        },
        toast: {
          created: "Grupi i pyetësorëve u krijua me sukses",
          createError: "Dështoi krijimi i grupit të pyetësorëve",
          memberAdded: "Pyetësori u shtua në grup",
          memberRemoved: "Pyetësori u hoq nga grupi",
          orderSaved: "Renditja u përditësua",
          detailsSaved: "Detajet e grupit u ruajtën",
          deleted: "Grupi i pyetësorëve u fshi me sukses",
          linkCreated: "Linku i grupit u krijua",
          linkError: "E pamundur të krijohet linku",
          linkUpdated: "Linku i grupit u përditësua",
          renamed: "Grupi u riemërtua me sukses",
          renameError: "Dështoi riemërtimi i grupit",
          deleteError: "Dështoi fshirja e grupit",
          selectAtLeastOne: "Zgjidhni të paktën një pyetësor për të krijuar një grup",
          languageDuplicateSkipped: "Disa pyetësorë u anashkaluan për shkak të gjuhëve të dyfishta"
        },
        steps: {
          createTitle: "Krijo grupe logjike",
          createDesc: "Zgjidhni pyetësorët e lokalizuar që i përkasin së bashku.",
          orderTitle: "Kontrollo rendin & primarin",
          orderDesc: "Tërhiqni për të rirenditur dhe vendosni përvojën e paracaktuar të pyetësorit.",
          publishTitle: "Publiko lidhje shumëgjuhëshe",
          publishDesc: "Ndani një URL dhe lejoni përgjigjet të ndërrojnë gjuhët."
        },
        table: {
          name: "Emri i grupit",
          languages: "{{count}} gjuhë",
          primary: "Pyetësori primar",
          updated: "Krijuar",
          actions: "Veprimet"
        },
        actions: {
          manage: "Menaxho anëtarët",
          edit: "Redakto",
          linkWorkspace: "Lidh hapësirën e punës"
        },
        emptyState: "Ende nuk ka grupe pyetësori. Krijoni grupin tuaj të parë për të filluar.",
        links: {
          heading: "URL-të e grupit",
          subheading: "Menaxho lidhjet për {{name}}",
          closeWorkspace: "Mbyll hapësirën e punës",
          previewLabel: "Linku bazë",
          previewPlaceholder: "Pamja paraprake e URL-së së grupit do të shfaqet këtu",
          empty: "Ende nuk janë krijuar lidhje për këtë grup."
        },
        slugLabel: "Slug i grupit",
        previewLabel: "Linku bazë",
        previewPlaceholder: "Pamja paraprake e URL-së së grupit",
        addToGroupBtn: "Shto pyetësorin e zgjedhur"
      },
      question: {
        title: "Ndërtuesi i pyetje & përgjigje",
        multi: "Zgjedhje të shumta",
        text: "Tekst",
        scale: "Shkalla e opinionit",
        q: "P",
        del1: "Fshij pyetjen",
        del2: "Jeni i sigurt që dëshironi të fshini pyetjen? Fshirja e llojit të pyetjes do të rezultojë në fshirjen e të gjitha të dhënave të lidhura me këtë pyetje.",
        enter: "Ju lutemi shkruani pyetjen",
        editq: "Modifiko pyetjen",
        duplicateq: "Dyfisho pyetjen",
        recorder: "Rirendit pyetjen",
        addq: "Shto pyetje",
        adds: "Shto seksion",
        questions: "Pyetjet",
        question: "Pyetja",
        sections: "Seksionet",
        name: "Emri i seksionit",
        description: "Shtoni përshkrimin tuaj të pyetësorit këtu",
        del_section1: "Fshini këtë seksion?",
        del_section2: "Ju lutemi zgjidhni një opsion për të vazhduar",
        del_section3: " Fshij këtë seksion dhe bashko pyetjet me",
        del_section4: "Fshij këtë seksion me të gjitha pyetjet e tij.",
        next: "tjetër",
        previous: "i mëparshëm",
        texts: "Emri i pyetësorit është i kërkuar",
        edits: "Modifiko seksionin",
        duplicates: "Dyfisho seksionin",
        recorders: "Rirendit seksionin",
        deletes: "Fshij seksionin",
      },
      sidebar: {
        email_templates: "Modelet e email-it",
        webhooks: "Webhooks",
        cookie_policy: "Politika e cookies",
      },
      email_template: {
        breadcrumb: "Modeli i email-it",
        page_title: "Redaktori i modelit të email-it",
        email_subject: "Subjekti i email-it",
        subject_placeholder: "Raporti juaj është gati",
        email_enabled: "Email-i i aktivizuar",
        email_disabled: "Email-i i çaktivizuar",
        reset_to_default: "Rivendos te paracaktuar",
        saving: "Duke ruajtur...",
        save_template: "Ruaj modelin",
        toast_enabled: "Email-i i raportit u aktivizua",
        toast_disabled: "Email-i i raportit u çaktivizua",
        toast_saved: "Modeli i email-it u ruajt",
        toast_reverted: "U rikthye te modeli i email-it i paracaktuar",
        toast_copied: "U kopjua {{text}} — ngjiteni në çdo fushë teksti",
        toast_copy_fallback: "Kopjoni këtë: {{text}}",
        click_to_copy: "Klikoni për të kopjuar",
        section_general: "Të përgjithshme",
        section_heading: "Titulli",
        section_description: "Përshkrimi",
        section_button: "Butoni",
        section_notes: "Shënimet & asistenca",
        section_signoff: "Përfundimi",
        section_footer: "Fundi i faqes",
        section_placeholders: "Mbajtësit e vendit",
        label_email_bg: "Sfondi email",
        label_card_bg: "Sfondi kartës",
        label_font: "Fonti",
        label_padding: "Hapësira",
        label_color: "Ngjyra",
        label_font_size: "Madhësia e fontit",
        label_bg_color: "Ngjyra e sfondit",
        label_text_color: "Ngjyra e tekstit",
        label_section_bg: "Sfondi i seksionit",
        label_radius: "Radiusi",
        label_height: "Lartësia",
        label_width: "Gjerësia",
        label_border: "Kufiri",
        label_security_note: "Shënimi i sigurisë",
        label_assistance_note: "Shënimi i asistencës",
        placeholder_desc: "Klikoni një mbajtës vendi për ta kopjuar, pastaj ngjiteni në çdo fushë teksti në pamjen paraprake. Këto janë <strong>opsionale</strong> &mdash; nëse hiqni njërin, ajo vlerë thjesht nuk do të shfaqet në email-in e dërguar.",
        placeholder_org_name: "Emri i shfaqur i organizatës (p.sh. \"Vodafone Support\")",
        placeholder_support_email: "Adresa e email-it të mbështetjes (p.sh. \"support@vodafone.com\")",
        placeholder_report_url: "Lidhja e raportit të gjeneruar (futet automatikisht në buton)",
        reset_title: "Rivendos te paracaktuar",
        reset_warning: "Kjo do të rikthejë modelin e email-it në gjendjen e paracaktuar. Të gjitha personalizimet tuaja (teksti, ngjyrat, stilet) do të humbasin përgjithmonë.",
        reset_confirm: "Po, rivendos",
        reset_cancel: "Anulo",
      },
      cookie_policy_page: {
        breadcrumb: "Politika e cookies",
        page_title: "Politika e cookies",
        page_description: "Menaxhoni përmbajtjen e politikës së cookies për këtë pyetësor. Ndërroni dukshmërinë në fundin e pyetësorit.",
        show_in_footer: "Shfaq politikën e cookies në fundin e pyetësorit",
        enabled: "Aktivizuar",
        disabled: "Çaktivizuar",
        banner_settings: "Cilësimet e butonave të bannerit të cookies",
        accept_button: "Butoni prano",
        reject_button: "Butoni refuzo",
        show: "Shfaq",
        hidden: "Fshehur",
        button_text_label: "Teksti i butonit (lëreni bosh për përkthimin e paracaktuar)",
        accept_placeholder: "p.sh. Prano të gjitha cookies",
        reject_placeholder: "p.sh. Refuzo të gjitha",
        saving: "Duke ruajtur...",
        save: "Ruaj",
      },
    },
    privacyPolicy: {
      heading: "Politika e privatësisë",
      title: "Konfiguroni ose bashkëngjitni politikën tuaj të privatësisë të pyetësorit këtu."
    },
    activityLog: {
      title: "Regjistri i aktivitetit",
      message: "Mesazhi",
      action: "Veprimi",
      added_by: "Shtuar nga",
      date_time: "Data & ora",
    },
    activityTemplate: {
      title: "Shabloni i regjistrave të aktivitetit",
      add: "Shto shablon aktiviteti",
      TemplateAction: "Veprimi i shablonitit",
      TemplateText: "Teksti i shablonitit",
      TemplateCode: "Kodi i shablonitit",
      AddedBy: "Shtuar nga",
      AddedDate: "Data e shtuar",
      addTemplateCodeLabel: "Kodi i shablonitit",
      TemplateCodePlaceholder: "Shkruani kodin e shablonitit...",
      TemplateActionLabel: "Veprimi i shablonitit",
      TemplateActionPlaceholder: "Shkruani veprimin e shablonitit...",
      TemplateTextLabel: "Teksti i shablonitit",
      TemplateTextPlaceholder: "Shkruani tekstin e shablonitit...",
      DependencyArrayLabel: "Varg i varësive",
      DependencyArrayPlaceholder: "Shkruani vargun e varësive...",
      desc: "Regjistri i Aktivitetit ofron një regjistrim të plotë të të gjitha veprimeve dhe ngjarjeve brenda sistemit. Ju lejon të gjurmoni ndryshimet dhe të monitoroni aktivitetin e përdoruesit.",
    },
    activityLogTemplate: {
      templateCodeRequired: "Kodi i shablonitit është i kërkuar",
      templateActionRequired: "Veprimi i shablonitit është i kërkuar",
      templateTextRequired: "Teksti i shablonitit është i kërkuar",
      dependencyArrayRequired: "Vargu i varësive është i kërkuar",
    },

    analytics: {
      title: "Analitikë",
      heading: "Analitikë",
      select: "Zgjidh pyetësorin",
      text1: "Shiko të gjitha",
      select_survey: "Zgjidh pyetësorin",
      date: "Data",
      completion_analysis: "Analiza e përfundimit",
      maturity_analysis: "Analiza e pjekurisë",
      question_wise: "Sipas pyetjeve",
      exits_analysis: "Analiza e daljeve",
      last_month: "Muaji i kaluar",
      last7: "7 ditët e fundit",
      this: "Këtë muaj",
      last30: "30 ditët e fundit",
      today: "Sot",
      yesterday: " Dje",
      notAns: "Nuk u përgjigj",
      complete: "I plotë",
      question: "Pyetjet",
      respondentCount: "Numri i përgjigjësve",
      surveyCount: "Numri i pyetësorëve",
      inComplete: "I paplotë",
      all: "Të gjitha",
      link: "Linku",
      utm_source: "Burimi UTM",
      utm_medium: "Mediumi UTM",
      utm_campaign: "Fushata UTM",
      del1: "Fshirja e kësaj lidhjeje do ta heqë përgjithmonë nga sistemi. Jeni i sigurt që dëshironi të vazhdoni?",
      del2: "Fshij lidhjen",
      del3: "Fshij lidhjet e zgjedhura",
      del4: "lidhjet e zgjedhura? Ky veprim nuk mund të zhbëhet.",
      TANDC: "Prefët e marketingut",

      top_10_leads: {
        heading: "10 lidhjet kryesore të gjeneruara",
        description:
          "Shfaq detajet e 10 lidhjeve kryesore të gjeneruara. Klikoni në çdo kolonë për të renditur të dhënat. Eksportoni në Excel për analizë të detajuar.",
      },
      date_of_survey: "Data e pyetësorit",
      report_link: "Linku i raportit",
      first_name: "Emri",
      last_name: "Mbiemri",
      email_address: "Adresa Email",
      phone_number: "Numri i telefonit",
      organization_name: "Emri i organizatës",
      industry: "Industria",
      number_of_responses: "Nr. i përgjigjeve",
      maturity_level: "Niveli i pjekurisë",
      total_score: "Rezultati total",
      completed: "I plotësuar",
      unique_id: "ID Unik",
      tab_all: "Të gjitha",
      tab_archived: "Arkivuar",
      archived_by_rule: "Arkivuar nga rregulli",
      delete_permanently: "Fshi përgjithmonë",
      totals: {
        total_survey_responses: "Përgjigjet totale të pyetësorëve",
        completed_surveys: "Pyetësorë të plotësuar",
        completed_leads: "Lidhje të plotësuara",
      },
    },
    settings: {
      title: "Cilësimet",
      general: "Cilësimet e përgjithshme",
      general_breadcrumb: "Cilësimet e përgjithshme",
      account_settings: {
        heading: "Profili",
        email: "Email",
        user_name: "Emri i përdoruesit",
        country: "Vendi",
        region: "Rajoni",
        timezone: "Zona kohore",
        save_changes: "Ruaj ndryshimet",
        default_language: "Gjuha e paracaktuar",
        assignTeamRole: "Ekipet dhe rolet e caktuara",
      },
      security: "Siguria",
      ticket_notifications: "Njoftimet",
      organization_details: {
        heading: "Detajet e organizatës",
        breadcrumb_heading: "Detajet e organizatës",
        privacy_policy: "Politika e privatësisë",
        terms_of_use: "Kushtet e përdorimit",
        cookie_policy: "Politika e cookies",
      },
      users_and_teams: {
        heading: "Menaxhimi i përdoruesve",
        breadcrumb_heading: "Menaxhimi i përdoruesve",
        users: {
          heading: "Përdoruesit",
          sub_heading:
            "Menaxho qasjen e produktit për të gjithë përdoruesit në organizatën tuaj.",
          search: "Kërko",
          name: "Emri",
          action: "Veprimi",
          edit_action: {
            edit_user: "Modifiko përdoruesin",
            full_name: "Emri i plotë",
            email_address: "Adresa Email",
            password: "Fjalëkalimi",
            cancel: "Anulo",
            save: "Ruaj",
            recently: "Shtuar kohët e fundit",
            sorta: "Rendit A-Z",
            sortb: "Rendit Z-A",
          },
          delete_action: {
            heading: "Fshij përdoruesit",

            sub_heading: "Paralajmërim",
            cancel: "Anulo",
            confirm_delete: "Konfirmo fshirjen",
            text1:
              "Jeni i sigurt që dëshironi të fshini këta përdorues përgjithmonë?",
            text2:
              "Duke fshirë përdoruesit, do t'i fshini nga të gjithë Pyetësorët dhe lejen e tyre për të hyrë.",
          },
          create_user: {
            heading: "Krijo përdorues",
            full_name: "Emri i plotë",
            email_address: "Adresa Email",
            password: "Fjalëkalimi",
            cancel: "Anulo",
            save: "Ruaj",
            enter: "Shkruaj",
          },
        },
      },
      roles: {
        heading: "Rolet",
        description:
          "Rolet janë sete të paracaktuara të lejeve dhe përgjegjësive që caktohen.",
        common: {
          role_name: "Emri i rolit",
          select_parent_role: "Zgjidh rolin prind",
          permissions: {
            heading: "Lejet",
            survey: "Pyetësori",
            analytics: "Analitikë",
            users: "Përdoruesit",
            roles: "Rolet",
            teams: "Ekipet",
            actions: {
              view: "Shiko",
              write: "Shkruaj",
              read: "Lexo",
              delete: "Fshij",
            },
          },
          cancel: "Anulo",
          save: "Ruaj",
        },
        create_role: {
          heading: "Krijo rol",
          add_new: "Shto të ri ",
          role: "Rol",
          edit: "Modifiko",
        },
        role_list: {
          sr_no: "Nr.rr",
          name: "Emri",
          date_added: "Data e shtuar",
          action: "Veprimi",
        },
        edit_action: {
          edit_role: "Modifiko rolin",
        },
        delete_action: {
          heading: "Fshij përdoruesit",
          sub: "Fshij rolin",
          sub_heading:
            "Duke fshirë rolin e përdoruesit, do ta fshini rolin e përdoruesit nga të gjithë Serverët dhe lejen e tyre për të hyrë.",
          cancel: "Anulo",
          delete: "Fshij",
        },
      },
      team: {
        heading: "Ekipet",
        description:
          "Ekipet janë grupe përdoruesish që punojnë së bashku në projekte ose detyra specifike.",
        create_team: {
          heading: "Krijo ekip",
          team_name: "Emri i ekipit",
          save: "Ruaj",
          cancel: "Anulo",
          member: "Anëtarët",
        },
        action: {
          edit: "Modifiko",
          edit_team: "Modifiko ekipin",
          team_name: "Emri i ekipit",
          save: "Ruaj",
          cancel: "Anulo",
          add_member: "Shto anëtar",
          select_role: "Zgjidh rolin",
          added_members: "Anëtarët e shtuar",
          leave: "Largohu",
          owner: "Pronar",
          delete: {
            heading: "Fshij ekipin",
            warning: "Paralajmërim",
            text: "Duke fshirë këtë ekip, do të fshini të gjithë anëtarët e ekipit dhe informacionin e lidhur.",
            cancel: "Anulo",
            confirm_delete: "Konfirmo",
          },
        },
        sort_by: "Rendit sipas",
      },
      integration: {
        tittle: "Integrimi",
        text: "Mund të krijoni një urë midis formularit eloqua dhe formularit të vlerësimit.",
        eloqua: "Eloqua",
        save: "Ruaj",
        formURL: "URL-ja e formularit",
        companyName: "Emri i kompanisë",
        userName: "Emri i përdoruesit",
        password: "Fjalëkalimi",
        settings: "Cilësimet",
      },
      questionnaire: {
        title: "Pyetësori",
        "assessments​": "Vlerësimet​",
        pageHeading: "Titulli i faqes",
        buttontext: "Teksti i butonit",
        buttonNextText: "Butoni tjetër",
        buttonHeadingText: "Butoni dërgo",
        buttonBack: "Butoni kthehu",
        save: "Ruaj",
        reportPageHeading: "Titulli i faqes së raportit",
        reportHeading: "Titulli i raportit",
        stage: "Faza",
        stage1: "Faza 1",
        stage2: "Faza 2",
        stage3: "Faza 3",
        stage4: "Faza 4",
        stage5: "Faza 5",
        report: "Raporti",
        hint: " Ju lutemi shkruani ndihmën",
        choice: "Zgjedhja",
      },
      thankyouPage: {
        title: "Faqja e falënderimit",
        pageHeading: "Titulli i faqes",
        pageDescription: "Përshkrimi i faqes",
        buttonText1: "Butoni shiko raportin",
        buttonText2: "Butoni shkarko raportin",
      },
      CustomVairable: {
        linkCustom: "Lidh një variabël të personalizuar",
        variableLabel: "Etiketa e variablit",
        variableName: "Emri i variablit",
        value: "Vlera",
        action: "Veprimi",
        noDataFound: "Nuk u gjetën të dhëna",
        editVariable: "Modifiko variablin",
        addVariable: "Shto variabël",
        deleteVariable: "Fshij variablin",
        enterValue: "Shkruaj vlerën",
        cancel: "Anulo",
        save: "Ruaj",
        loading: "Duke ngarkuar...",
        confirmDelete: "Konfirmo fshirjen",
        areYouSure: "Jeni i sigurt që dëshironi të fshini variablin",
        addSection: "Shto seksion",
        editSection: "Modifiko seksionin",
        duplicateSection: "Dyfisho seksionin",
        reorderSection: "Rirendit seksionin",
        deleteSection: "Fshij seksionin",
        selectVariable: "Zgjidh variablin",
        newchoices: "Shto zgjedhje të reja",
        score: "Rezultati",
        variable: "Variabli",
        select: "Zgjidh",
      },
      save_changes: "Ruaj ndryshimet",
      loading: "Duke ngarkuar...",
      loading_settings: "Duke ngarkuar cilësimet...",
      security_settings: {
        title: "Cilësimet e sigurisë",
        description: "Konfiguro sigurinë e hyrjes për të gjithë përdoruesit.",
        sso_title: "Microsoft SSO",
        sso_description: "Lejo përdoruesit të hyjnë duke përdorur llogarinë e tyre Microsoft (Azure AD). Kur është çaktivizuar, butoni \"Hyr me Microsoft\" do të fshihet nga faqja e hyrjes.",
        mfa_title: "Autentifikimi me shumë faktorë (MFA)",
        mfa_description: "Kur është aktivizuar, përdoruesit duhet të verifikojnë identitetin e tyre me një kod 6-shifror të dërguar në email-in e tyre pasi të kenë shkruar fjalëkalimin. Kodi skadon pas 10 minutash.",
        lockout_title: "Bllokimi i llogarisë",
        lockout_description: "Blloko automatikisht llogaritë e përdoruesve pas përpjekjeve të shumta të dështuara të hyrjes për të parandaluar sulmet me forcë brutale.",
        max_attempts: "Përpjekjet maksimale të dështuara",
        lock_duration: "Kohëzgjatja e bllokimit",
        minutes: "minuta",
        password_expiry_title: "Skadimi i fjalëkalimit",
        password_expiry_description: "Detyroni përdoruesit të ndryshojnë fjalëkalimin pas një numri të caktuar ditësh. Përdoruesit do të ridrejtohen në një faqe të rivendosjes së fjalëkalimit kur hyjnë nëse fjalëkalimi ka skaduar.",
        expire_after: "Skadon pas",
        disabled: "Çaktivizuar",
        days: "ditë",
        success: "Cilësimet e sigurisë u përditësuan me sukses",
        error: "Dështoi përditësimi i cilësimeve",
      },
      ticket_notification_settings: {
        title: "Cilësimet e njoftimeve të biletave",
        description: "Zgjidhni përdoruesit që duhet të marrin njoftimet me email kur krijohet një biletë e re ose kur caktohet një biletë.",
        recipients_title: "Marrësit e njoftimeve me email",
        recipients_description: "Këta përdorues do të marrin një email sa herë që krijohet një biletë (nga një përdorues ose automatikisht nga sistemi). Gjithashtu, kur një biletë i caktohet një përdoruesi, ai përdorues do të marrë një email njoftimi caktimi.",
        add_users: "Shto përdorues",
        search_placeholder: "Kërko përdorues sipas emrit ose emailit...",
        no_users: "Asnjë përdorues i zgjedhur. Kërkoni dhe shtoni përdorues më sipër.",
        remove: "Hiq",
        success: "Marrësit e njoftimeve u përditësuan me sukses",
        error: "Dështoi përditësimi i marrësve",
      },
      organization_details_page: {
        edit_description: "Modifikoni përmbajtjen e {{title}} të shfaqur në faqen e hyrjes.",
        success: "{{title}} u përditësua me sukses",
        error: "Dështoi përditësimi",
      },
      editor: {
        bold: "I trashë",
        italic: "I pjerrët",
        underline: "I nënvizuar",
        bulleted_list: "Listë me pika",
        numbered_list: "Listë e numëruar",
        link: "Lidhje",
        table: "Tabelë",
        text_color: "Ngjyra e tekstit",
        color: "Ngjyra",
        no_color: "Pa ngjyrë",
        url_prompt: "URL",
      },
    },
    tickets: {
      title: "Biletat",
      create_ticket: "+ Krijo biletë",
      search_placeholder: "Kërko bileta...",
      no_tickets: "Nuk u gjetën bileta",
      created_success: "Bileta u krijua me sukses",
      view: "Shiko",
      view_details: "Shiko detajet e biletës",
      dashboard: {
        open: "Hapur",
        acknowledged: "Pranuar",
        in_progress: "Në progres",
        resolved: "Zgjidhur",
        total: "Totali",
      },
      status: {
        open: "Hapur",
        acknowledged: "Pranuar",
        in_progress: "Në progres",
        resolved: "Zgjidhur",
        false_positive: "Pozitiv i rremë",
      },
      alert_type: {
        brute_force: "Forcë brutale",
        unauthorized_token: "Token i paautorizuar",
        unknown_user: "Përdorues i panjohur",
        inactive_user: "Përdorues joaktiv",
        suspicious_ip: "IP i dyshimtë",
        after_hours: "Jashtë orarit",
        manual: "Manual",
      },
      columns: {
        title: "Titulli",
        type: "Lloji",
        severity: "Ashpërsia",
        status: "Statusi",
        source: "Burimi",
        assigned_to: "Caktuar tek",
        created: "Krijuar",
        action: "Veprimi",
      },
      filters: {
        all_statuses: "Të gjitha statuset",
        all_severities: "Të gjitha ashpërsitë",
        all_sources: "Të gjitha burimet",
        all_assignees: "Të gjithë të caktuarit",
        unassigned: "Pa caktuar",
      },
      severity: {
        low: "Ulët",
        medium: "Mesatare",
        high: "Lartë",
        critical: "Kritike",
      },
      source: {
        system: "Sistemi",
        user: "Përdoruesi",
      },
      create: {
        title: "Krijo biletë",
        title_label: "Titulli *",
        title_placeholder: "Përshkrim i shkurtër i problemit",
        title_required: "Titulli është i kërkuar",
        title_max: "Titulli duhet të jetë 255 karaktere ose më pak",
        severity_label: "Ashpërsia *",
        severity_required: "Ashpërsia është e kërkuar",
        severity_placeholder: "Zgjidhni ashpërsinë...",
        description_label: "Përshkrimi",
        description_max: "Përshkrimi duhet të jetë 2000 karaktere ose më pak",
        description_placeholder: "Jepni detaje shtesë...",
        assign_to: "Cakto tek",
        unassigned: "Pa caktuar",
        cancel: "Anulo",
        creating: "Duke krijuar...",
        submit: "Krijo biletë",
      },
      detail: {
        back: "Kthehu te biletat",
        not_found: "Bileta nuk u gjet.",
        status: "Statusi",
        severity: "Ashpërsia",
        alert_type: "Lloji i alarmit",
        source: "Burimi",
        ip_address: "Adresa IP",
        raised_by: "Krijuar nga",
        assigned_to: "Caktuar tek",
        created: "Krijuar",
        resolved: "Zgjidhur",
        resolved_by: "nga {{name}}",
        comments: "Komentet ({{count}})",
        no_comments: "Ende pa komente.",
        unknown_user: "I panjohur",
        add_comment_placeholder: "Shto një koment...",
        posting: "Duke postuar...",
        post_comment: "Posto komentin",
        update_status: "Përditëso statusin",
        updating: "Duke përditësuar...",
        assign_to: "Cakto tek",
        select_user: "Zgjidh përdoruesin...",
        assigning: "Duke caktuar...",
        assign_btn: "Cakto",
        status_updated: "Statusi u përditësua",
        status_update_failed: "Dështoi përditësimi i statusit",
        assigned: "Bileta u caktua",
        assign_failed: "Dështoi caktimi i biletës",
        comment_added: "Komenti u shtua",
        comment_failed: "Dështoi shtimi i komentit",
      },
    },
    documentation: {
      ...docTranslations.sq.documentation,
      title: "Dokumentacioni",
    },

    webhook: {
      url: "URL",
      title: "webhooks",
      webhook: "webhook",
      createTitle: "Krijo webhook të ri",
      editTitle: "Modifiko webhook",
      name: "Shkruaj emrin",
      event: "Ngjarjet",
      add: "Shto webhook",
      desc: "Shkruaj përshkrimin",
      active: "Aktiv",
      inactive: "Joaktiv",
      generateURl: "URL-ja e gjeneruar e webhook",
      delete: "Fshij webhook",
      delete1:
        "Fshirja e këtij webhook do të çaktivizojë shkaktarët e tij për të gjitha ngjarjet me të cilat është i lidhur. Ky veprim nuk mund të zhbëhet. Jeni i sigurt?",
      recently: "Shtuar kohët e fundit",
      example: "https\\:example4.com",
      remove: "Hiq",
      assign: "Cakto ekipin",

      method: "Metoda",
      content_type: "Lloji i përmbajtjes",
      data_format: "Formati i të dhënave",
      parameters: "Parametrat",
      preview: "Pamja paraprake",

      validation: {
        name_required: "Emri është i kërkuar",
        url_required: "URL-ja është e kërkuar",
        url_invalid: "URL e pavlefshme",
        event_required: "Ngjarја është e kërkuar",
        http_method_required: "Metoda HTTP është e kërkuar",
        http_method_oneof: "Metodë HTTP e pavlefshme",
        content_type_required: "Lloji i përmbajtjes është i kërkuar",
        data_format_required: "Formati i të dhënave është i kërkuar",
        data_format_invalid: "Format i pavlefshëm i të dhënave",
        params_name_required: "Emri është i kërkuar",
        params_value_required: "Vlera është e kërkuar",
        get_no_body:
          "Kërkesat GET nuk mund të kenë trupin e kërkesës. Ju lutemi përdorni Parametrat e Pyetjes për kërkesat GET.",
      },
    },
    sync: {
      syncFromUat: "Sinkronizo nga UAT",
      versionHistory: "Historiku i versioneve",
      survey: "Pyetësori",
      mode: "Mënyra",
      fullReplacement: "Zëvendësim i plotë",
      merge: "Bashko",
      cancel: "Anulo",
      next: "Tjetër",
      loading: "Duke ngarkuar...",
      sync: "Sinkronizo",
      syncing: "Duke sinkronizuar...",
      close: "Mbyll",
      acceptAndSync: "Prano dhe sinkronizo",
      merging: "Duke bashkuar...",
      loadingSurveys: "Duke ngarkuar pyetësorët...",
      noSurveysFound: "Nuk u gjetën pyetësorë.",
      fullReplacementNote: "Një version snapshot do të krijohet para zëvendësimit për të lejuar kthimin prapa nëse është e nevojshme.",
      mergeNote: "Kliko Tjetër për të parë artikujt e rinj dhe konfliktet. Versioni UAT do të përdoret për konflikte.",
      noteLabel: "Shënim:",
      mergeModeLabel: "Mënyra e bashkimit:",
      showLatestVersions: "Shfaq vetëm 5 versionet e fundit",
      version: "Versioni",
      type: "Lloji",
      date: "Data",
      action: "Veprimi",
      loadingVersions: "Duke ngarkuar versionet...",
      beforeRestore: "Para restaurimit",
      beforeRestoreToVersion: "Para restaurimit te Versioni",
      beforeMerge: "Para bashkimit nga UAT",
      beforeSync: "Para sinkronizimit nga UAT",
      restoring: "Duke restauruar...",
      restore: "Restauro",
      noVersionsFound: "Nuk u gjetën versione.",
      mergePreview: "Pamja paraprake e bashkimit",
      conflictsWarning: "Konflikte",
      conflictsDescription: "I njëjti UUID, përmbajtje e ndryshme. Versioni UAT do të zëvendësojë Primarin.",
      newItems: "Artikuj të rinj",
      duplicatesWarning: "Dublikat",
      duplicatesDescription: "UUID i ndryshëm, përmbajtje e njëjtë. Të dy versionet do të mbahen.",
      noChanges: "Nuk ka ndryshime për të bashkuar. Pyetësori është tashmë i sinkronizuar.",
      new: "I ri",
      conflicts: "Konflikte",
      duplicates: "Dublikat",
      questions: "Pyetjet",
      sections: "Seksionet",
      variables: "Variablat",
      leadGenVariables: "Variablat e gjenerimit të lidhjeve",
      utmVariables: "Variablat UTM",
      customFormulas: "Formulat e personalizuara",
      stages: "Fazat",
      reportPages: "Faqet e raportit",
      customVariableValues: "Vlerat e variablave të personalizuar",
      reports: "Raportet",
      surveyLinks: "Linqet e pyetësorit",
      webhooks: "Webhooks",
      privacyPolicy: "Politika e privatësisë",
      questionnaire: "Pyetësori",
      thankYouPage: "Faqja e falënderimit",
      toast: {
        linkCopied: "Linku u kopjua në clipboard",
        invalidVersionSelected: "Version i pavlefshëm i zgjedhur",
        restoredSuccess: "Restauruar në v{{version}}! Backup v{{backup}} u krijua.",
        restoreFailed: "Dështoi restaurimi i versionit",
        noSurveySelected: "Asnjë pyetësor i zgjedhur për sinkronizim",
        syncCompletedWithBackup: "Sinkronizimi u plotësua! Versioni v{{version}} u krijua si backup.",
        surveySyncedSuccess: "Pyetësori u sinkronizua me sukses",
        fullReplacementFailed: "Dështoi zëvendësimi i plotë",
        clickPreviewFirst: "Ju lutemi klikoni Tjetër për të parë ndryshimet para bashkimit",
        previewFailed: "Pamja paraprake dështoi",
        mergeCompletedSuccess: "Bashkimi u plotësua me sukses",
        mergeFailed: "Bashkimi dështoi",
        surveyDuplicatedSuccess: "Pyetësori u dyfishua me sukses",
        surveyDuplicateFailed: "Dështoi dyfishimi i pyetësorit. Ju lutemi provoni përsëri.",
        surveyDeletedSuccess: "Pyetësori u fshi me sukses",
        surveyDeleteFailed: "Dështoi fshirja e pyetësorit. Ju lutemi provoni përsëri.",
        selectSurveyToSync: "Ju lutemi zgjidhni një pyetësor për të sinkronizuar.",
        fetchUatSurveysFailed: "Dështoi ngarkimi i pyetësorëve UAT",
        noGroupSelected: "Asnjë grup i zgjedhur.",
        noSurveysSelectedToAdd: "Asnjë pyetësor i zgjedhur për t'u shtuar.",
        surveysAddedToGroup: "{{count}} pyetësor(ë) u shtua në {{groupName}} me sukses.",
        duplicateLanguagesWarning: "Nuk mund të shtohen pyetësorë me gjuhë të dyfishta në të njëjtin grup",
        failedToAddSurveys: "Dështoi shtimi i disa pyetësorëve",
      },
    },
  },
},
  },
});
